webpackJsonp([0],{

/***/ "+Dtb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("J0xC");
var dPs = __webpack_require__("fkkt");
var enumBugKeys = __webpack_require__("Y85c");
var IE_PROTO = __webpack_require__("kXVo")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("JWjT")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("k8O+").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "+PgN":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("TRtI")('wks');
var uid = __webpack_require__("6bUA");
var Symbol = __webpack_require__("iY05").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "+V16":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Vjiw");
var $Object = __webpack_require__("gfTL").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "/FIT":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("84ik");
var TAG = __webpack_require__("+PgN")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "/XSW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DebouncedResizeManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ThrottledResizeManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__optimised_event_manager__ = __webpack_require__("uRdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_throttle__ = __webpack_require__("f9aD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_debounce__ = __webpack_require__("bbx/");





var DebouncedResizeManager = new __WEBPACK_IMPORTED_MODULE_0__optimised_event_manager__["a" /* default */]({
  func: __WEBPACK_IMPORTED_MODULE_2__utilities_debounce__["a" /* default */],
  event: "resize",
  newEvent: "debouncedResize",
  rate: 300
});

var ThrottledResizeManager = new __WEBPACK_IMPORTED_MODULE_0__optimised_event_manager__["a" /* default */]({
  func: __WEBPACK_IMPORTED_MODULE_1__utilities_throttle__["a" /* default */],
  event: "resize",
  newEvent: "throttledResize"
});

/***/ }),

/***/ "/fps":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("PPsw");
__webpack_require__("Et2G");
module.exports = __webpack_require__("7Q5m").f('iterator');


/***/ }),

/***/ "0Khi":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("J7qu");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("v8Hs") });


/***/ }),

/***/ "0Qy9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("tB/S"), __esModule: true };

/***/ }),

/***/ "0bh+":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("fAwT");
var invoke = __webpack_require__("id70");
var html = __webpack_require__("k8O+");
var cel = __webpack_require__("JWjT");
var global = __webpack_require__("iY05");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("84ik")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "1lYT":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("hS2E");
var toLength = __webpack_require__("Hy4L");
var toAbsoluteIndex = __webpack_require__("YlTb");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "25lL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__load_manager__ = __webpack_require__("Q9B1");




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_2__load_manager__["b" /* default */].queue(function () {

  var els = Object(__WEBPACK_IMPORTED_MODULE_1__utilities_selector__["a" /* $ */])('.cms table');
  if (!els) return;

  function applyTableKeys(table) {
    var rows = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(table.querySelectorAll("tr"))).map(function (el) {
      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(el.querySelectorAll("td,th")));
    });
    var headings = rows.shift();
    rows.forEach(function (cells) {
      cells.forEach(function (cell, i) {
        cell.setAttribute("data-key", headings[i].textContent);
      });
    });
  }

  [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(els)).forEach(applyTableKeys);
}, __WEBPACK_IMPORTED_MODULE_2__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "2Y3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CarouselPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

function CarouselPlugin() {
  if (!(this instanceof CarouselPlugin)) return new CarouselPlugin();
}

CarouselPlugin.prototype.enable = function (carousel) {
  // Store carousel reference
  this.carousel = carousel;

  // Push any elements this plugin uses
  if (this.options && this.options.elements && this.options.elements.length) carousel.pushElement.apply(carousel, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.options.elements));

  return this;
};

CarouselPlugin.displayName = "CarouselPlugin";

CarouselPlugin.prototype.init = function () {};

CarouselPlugin.prototype.destroy = function () {};

/***/ }),

/***/ "48TN":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("LUWG");
var createDesc = __webpack_require__("wRUo");
var toIObject = __webpack_require__("hS2E");
var toPrimitive = __webpack_require__("UMw4");
var has = __webpack_require__("8nki");
var IE8_DOM_DEFINE = __webpack_require__("xkmf");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("EPcB") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "4dTo":
/***/ (function(module, exports) {



/***/ }),

/***/ "4yv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DNLinksPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base_plugin__ = __webpack_require__("2Y3a");







// Class
function DNLinksPlugin(config) {
  if (!(this instanceof DNLinksPlugin)) return new DNLinksPlugin(config);

  this.options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, DNLinksPlugin.defaults, config);
}

// Extends
DNLinksPlugin.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_4__base_plugin__["a" /* default */].prototype);
DNLinksPlugin.prototype.constructor = DNLinksPlugin;

// Static
DNLinksPlugin.displayName = "DNLinksPlugin";
DNLinksPlugin.defaults = {
  elements: [{
    key: 'links',
    multiple: true,
    selector: '[data-link]'
  }]
};

// Methods
DNLinksPlugin.prototype.init = function () {
  if (this.carousel.elements.links && this.carousel.elements.links.length) {
    [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.carousel.elements.links)).forEach(this.setupLinks, this);
  }
};

DNLinksPlugin.prototype.setupLinks = function (el, i) {

  var item = el.parentNode;
  var url = el.innerHTML.trim();

  if (url !== '' && url !== 'Link goes here') {
    item.style.cursor = "pointer";
  }

  item.addEventListener('click', function () {
    if (url !== '' && url != 'Link goes here') {
      if (url.indexOf('http') !== -1) {
        window.open(url, '_blank');
      } else {
        window.location = url;
      }
    }
  });
};

/***/ }),

/***/ "5LE+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("V0Rs");
var createDesc = __webpack_require__("wRUo");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "5zwf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIRECTION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("BX4+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("VOrx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("ZKjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__optimised_event_manager__ = __webpack_require__("uRdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_throttle__ = __webpack_require__("f9aD");









var DIRECTION = {
  FORWARD: 'FORWARD',
  BACKWARD: 'BACKWARD',
  PAUSED: 'PAUSED'
};

var ScrollManager = function (_OptimisedEventManage) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollManager, _OptimisedEventManage);

  function ScrollManager() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollManager);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollManager.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollManager)).call(this, {
      func: __WEBPACK_IMPORTED_MODULE_6__utilities_throttle__["a" /* default */],
      event: "scroll",
      newEvent: "optimizedScroll"
    }));

    _this.lastScrollPos = 0;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollManager, [{
    key: 'params',
    value: function params() {
      var pos = window.scrollY;
      var params = {
        size: pos,
        direction: this.direction(pos),
        progress: this.progress()
      };
      this.lastScrollPos = pos;
      return params;
    }
  }, {
    key: 'direction',
    value: function direction(newPos) {
      if (this.lastScrollPos < newPos) {
        return DIRECTION.FORWARD;
      }

      if (this.lastScrollPos > newPos) {
        return DIRECTION.BACKWARD;
      }

      return DIRECTION.PAUSED;
    }

    // Get

  }, {
    key: 'progress',
    value: function progress() {
      return (window.scrollY / (document.body.scrollHeight - window.innerHeight)).toFixed(4);
    }
  }]);

  return ScrollManager;
}(__WEBPACK_IMPORTED_MODULE_5__optimised_event_manager__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new ScrollManager());

/***/ }),

/***/ "6BzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DotsCarouselPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_plugin__ = __webpack_require__("2Y3a");






// Class
function DotsCarouselPlugin(config) {
  if (!(this instanceof DotsCarouselPlugin)) return new DotsCarouselPlugin(config);

  this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, DotsCarouselPlugin.defaults, config);

  // Bind goto
  this.jump = this.jump.bind(this);
}

// Extends
DotsCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_3__base_plugin__["a" /* default */].prototype);
DotsCarouselPlugin.prototype.constructor = DotsCarouselPlugin;

// Static
DotsCarouselPlugin.displayName = "DotsCarouselPlugin";
DotsCarouselPlugin.defaults = {
  elements: [{
    key: 'dots',
    multiple: true,
    selector: '[data-js~=carousel-dot]'
    //scope: () => $1('[data-js~=carousel-dots]')
  }]
};

// Methods
DotsCarouselPlugin.prototype.init = function () {
  // Make sure we have dots
  if (this.carousel.elements.dots && this.carousel.elements.dots.length) {
    // cache dots
    this.dots = this.carousel.elements.dots;

    // setup dots
    this.dots.forEach(this.setupDot, this);

    // Update on change
    this.carousel.wallop.on('change', this.change.bind(this));
  }
};

DotsCarouselPlugin.prototype.setupDot = function (dot, i) {
  // Set current to active
  i !== this.carousel.wallop.currentItemIndex || dot.classList.add('is-active');

  // Add index data attr to item
  dot.setAttribute('data-index', i);

  // Setup click event
  dot.addEventListener('click', this.jump);
};

DotsCarouselPlugin.prototype.change = function (e) {
  var oldI = parseInt(this.carousel.wallop.previousItemIndex);
  var newI = parseInt(e.detail.currentItemIndex);
  isNaN(oldI) || this.dots[oldI].classList.remove('is-active');
  isNaN(newI) || this.dots[newI].classList.add('is-active');
};

DotsCarouselPlugin.prototype.jump = function (e) {
  var i = parseInt(e.currentTarget.getAttribute('data-index'));
  this.carousel.goTo(i);
};

/***/ }),

/***/ "6bUA":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "6mUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollTo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__("NQR3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__offset__ = __webpack_require__("cFxj");




function scrollTo(t, offset) {
  var autoplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!t) return;
  var body = document.scrollingElement || document.documentElement || document.body;
  var position = body.scrollTop;
  var o = Object(__WEBPACK_IMPORTED_MODULE_1__offset__["a" /* getOffset */])(t) + (offset || 0);
  // const diff = o - position;
  var pos = { scrollTop: position };
  var tween = __WEBPACK_IMPORTED_MODULE_0_animejs___default()({
    targets: pos,
    scrollTop: o,
    duration: 200,
    easing: 'easeInCubic',
    autoplay: false,
    update: function update() {
      body.scrollTop = pos.scrollTop;
    }
  });
  return autoplay ? tween.play() : tween;
}

/***/ }),

/***/ "6t7t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("/fps"), __esModule: true };

/***/ }),

/***/ "7Q5m":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("+PgN");


/***/ }),

/***/ "84ik":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "8FtN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("bPR/"), __esModule: true };

/***/ }),

/***/ "8QSD":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("8nki");
var toObject = __webpack_require__("Y2mk");
var IE_PROTO = __webpack_require__("kXVo")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "8h33":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("J7qu");
var core = __webpack_require__("gfTL");
var global = __webpack_require__("iY05");
var speciesConstructor = __webpack_require__("nj1l");
var promiseResolve = __webpack_require__("ilQA");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "8nki":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "9NUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AutoCarousels */
/* unused harmony export EventCarousels */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel__ = __webpack_require__("F5oK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins__ = __webpack_require__("SB6i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_manager__ = __webpack_require__("DBWF");





var AutoCarousels = new __WEBPACK_IMPORTED_MODULE_2__component_manager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__carousel__["a" /* default */], '[data-js~=carousel]', function () {
  return {
    plugins: [
    // VisibilityPlugin(),
    Object(__WEBPACK_IMPORTED_MODULE_1__plugins__["a" /* AutoPlugin */])({
      delay: 6000
    }), Object(__WEBPACK_IMPORTED_MODULE_1__plugins__["c" /* DotsPlugin */])(),
    // TouchPlugin(),
    Object(__WEBPACK_IMPORTED_MODULE_1__plugins__["b" /* DNLinksPlugin */])()]
  };
});

var EventCarousels = new __WEBPACK_IMPORTED_MODULE_2__component_manager__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__carousel__["a" /* default */], '[data-js~=carousel-events]', function () {
  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_1__plugins__["d" /* VisibilityPlugin */])(), Object(__WEBPACK_IMPORTED_MODULE_1__plugins__["a" /* AutoPlugin */])({
      delay: 6000
    }), Object(__WEBPACK_IMPORTED_MODULE_1__plugins__["c" /* DotsPlugin */])(),
    // TouchPlugin(),
    Object(__WEBPACK_IMPORTED_MODULE_1__plugins__["b" /* DNLinksPlugin */])()]
  };
});

/***/ }),

/***/ "9WN3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Map; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings__ = __webpack_require__("GiYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_map_style_json__ = __webpack_require__("XSTj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_map_style_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__settings_map_style_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__load_manager__ = __webpack_require__("Q9B1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__optimisations_async_resource_manager__ = __webpack_require__("G+h4");











var defaults = {
  lat: 0,
  lng: 0,
  z: 2
};

var API_KEY = "AIzaSyAbgl2g23LIdT23sCMopfmbEsWYsE-wXxo";
var API_URL = "https://maps.googleapis.com/maps/api/js?key=" + API_KEY;

var Map = function () {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Map, null, [{
    key: "getMarker",
    value: function getMarker(el) {
      return {
        icon: el.getAttribute("data-icon"),
        title: el.getAttribute("data-title"),
        address: el.getAttribute("data-address"),
        position: {
          lat: parseFloat(el.getAttribute("data-lat")),
          lng: parseFloat(el.getAttribute("data-lng"))
        },
        content: el.innerHTML
      };
    }
  }, {
    key: "markerAction",
    value: function markerAction() {
      if (!this instanceof google.maps.Marker) throw new Error("`this` was not a MapMarker");

      this.map.setCenter(this.getPosition());

      if (this.infoWindow) {
        this.infoWindow.open(this.map, this);
      }
    }
  }, {
    key: "disableMarker",
    value: function disableMarker(marker) {
      marker.instance.setMap(null);
    }
  }]);

  function Map(el) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Map);

    this.el = el || Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["b" /* $1 */])("[data-js=map]");
    this.ready = false;

    if (!this.el) return;

    this.init = this.init.bind(this);
    this.boundsChanged = this.boundsChanged.bind(this);

    this.fixedZoom = this.el.getAttribute("data-fixed-zoom");
    this.center = {
      lat: parseFloat(this.el.getAttribute("data-lat")) || defaults.lat,
      lng: parseFloat(this.el.getAttribute("data-lng")) || defaults.lng
    };
    this.zoom = parseInt(this.el.getAttribute("data-zoom")) || defaults.z;
    this.pin = this.el.getAttribute("data-pin");

    this.markers = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.el.children)).filter(function (x) {
      return x.hasAttribute("data-lat") && x.hasAttribute("data-lng");
    }).map(Map.getMarker, this);

    __WEBPACK_IMPORTED_MODULE_6__load_manager__["b" /* default */].queue(function () {
      // Ensures we always have the API before we initialise the map
      Object(__WEBPACK_IMPORTED_MODULE_7__optimisations_async_resource_manager__["a" /* loadResource */])(API_URL).then(_this.init);
    }, __WEBPACK_IMPORTED_MODULE_6__load_manager__["a" /* QUEUE */].RESOURCES);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Map, [{
    key: "init",
    value: function init() {
      var desktop = window.innerWidth >= __WEBPACK_IMPORTED_MODULE_3__settings__["a" /* default */].breakpoints.desktop;
      this.bounds = new google.maps.LatLngBounds();

      this.map = new google.maps.Map(this.el, {
        center: this.center,
        zoom: this.zoom,
        mapTypeControl: false,
        scrollwheel: false,
        styles: __WEBPACK_IMPORTED_MODULE_4__settings_map_style_json___default.a,
        disableDefaultUI: !desktop,
        disableDoubleClickZoom: !desktop,
        fullscreenControl: desktop,
        draggable: desktop
      });

      this.map.addListener("bounds_changed", this.boundsChanged);

      this.markers.forEach(this.addMarker, this);
      if (this.markers.length > 1) {
        this.map.fitBounds(this.bounds);
      }

      this.ready = true;
      this.el.dispatchEvent(new CustomEvent("ready", {
        detail: {
          map: this.map
        }
      }));
    }
  }, {
    key: "addMarker",
    value: function addMarker(item) {
      item.map = this.map;

      item.instance = new google.maps.Marker(item);

      if (item.content) {
        item.instance.infoWindow = new google.maps.InfoWindow({
          content: item.content
        });
      }

      this.bounds.extend(item.position);

      item.instance.addListener("click", Map.markerAction);
    }
  }, {
    key: "setMarkers",
    value: function setMarkers(markers) {
      this.clearMarkers();
      this.markers = markers;
      this.markers.forEach(this.addMarker, this);
      this.map.fitBounds(this.bounds);
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers() {
      this.markers.forEach(Map.disableMarker, this);
      this.markers = [];
    }
  }, {
    key: "boundsChanged",
    value: function boundsChanged() {
      if (!this.fixedZoom && this.map.getZoom() > this.zoom) {
        this.map.setZoom(this.zoom);
        this.fixedZoom = true;
      }
    }
  }]);

  return Map;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_6__load_manager__["b" /* default */].queue(function () {
  return new Map();
}, __WEBPACK_IMPORTED_MODULE_6__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "Aq8W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("KqgR"), __esModule: true };

/***/ }),

/***/ "BX4+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BfA1"), __esModule: true };

/***/ }),

/***/ "BfA1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gDg+");
module.exports = __webpack_require__("gfTL").Object.getPrototypeOf;


/***/ }),

/***/ "Bgb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var name = _ref.name,
      address1 = _ref.address1,
      address2 = _ref.address2,
      address3 = _ref.address3,
      town = _ref.town,
      postcode = _ref.postcode,
      telephone = _ref.telephone;
  return "<div class=\"Member\">\n  <h3 class=\"Member-title\">" + name + "</h3>\n  <address class=\"Member-address\">\n    " + [address1, address2, address3].filter(function (x) {
    return !!x;
  }).join(", ") + "\n    <br />" + town + "\n    <br />" + postcode + "\n  </address>\n  <a href=\"tel:" + telephone + "\" class=\"Member-tel\">" + telephone + "</a>\n</div>";
});

/***/ }),

/***/ "Bsd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseQuery */
/* harmony export (immutable) */ __webpack_exports__["a"] = stringifyQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("8FtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("Xos8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);



function parseQuery(str) {
  return str.substr(1).split('&').filter(function (x) {
    return !!x;
  }).map(function (x) {
    return x.split('=');
  }).reduce(function (prev, curr) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(prev, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, curr[0].toLowerCase(), curr[1]));
  }, {});
}

function stringifyQuery(obj) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  }).join('&');
}

/***/ }),

/***/ "CfMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormValidator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("8FtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_validate_js__ = __webpack_require__("Ntm8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_validate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_scrollto__ = __webpack_require__("6mUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_manager__ = __webpack_require__("DBWF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__load_manager__ = __webpack_require__("Q9B1");












var ObserverOptions = {
  attributes: true,
  attributeFilter: ["style"]
};

var FormValidator = function () {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FormValidator, null, [{
    key: "error",
    value: function error(_ref) {
      var _error = _ref.error,
          field = _ref.field;

      field.hasError = true;
      field.error.innerHTML = _error;
      field.container.insertBefore(field.error, field.container.children[0]);
      field.inputs.forEach(function (x) {
        return x.classList.add("is-invalid");
      });
    }
  }, {
    key: "clear",
    value: function clear(field) {
      field.hasError = false;
      field.container.removeChild(field.error);
      field.inputs.forEach(function (x) {
        return x.classList.remove("is-invalid");
      });
    }
  }, {
    key: "getFields",
    value: function getFields(fields, field) {
      var name = field.name || field.getAttribute("name");

      if (typeof fields[name] === "undefined") {
        var container = FormValidator.getContainer(field);
        if (!container) return fields;

        var type = FormValidator.getType(field);
        var error = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["b" /* $1 */])(".Form-error", container);

        fields[name] = {
          container: container,
          inputs: [],
          hasError: !!error,
          type: type,
          error: error || FormValidator.createError(type)
        };
      }

      fields[name].inputs.push(field);

      return fields;
    }
  }, {
    key: "getType",
    value: function getType(control) {
      return control.type || control.tagName.toLowerCase();
    }
  }, {
    key: "getConstraint",
    value: function getConstraint(constraints, field) {
      var name = field.name || field.getAttribute("name");

      constraints[name] = {};

      // Don"t try to validate disabled fields
      if (field.hasAttribute("disabled")) return constraints;

      // Required Validation
      if (FormValidator.isRequired(field)) {
        var msg = FormValidator.getMessage(field);

        constraints[name].presence = {
          allowEmpty: false
        };

        if (msg) {
          constraints[name].presence.message = "^" + msg;
        }
      }

      // Regex Validation
      if (field.hasAttribute("data-val-regex")) {
        constraints[name].format = {
          pattern: field.getAttribute("data-regex"),
          message: "^" + field.getAttribute("data-val-regex")
        };
      }

      // Matches Validation
      if (field.hasAttribute("data-match")) {
        constraints[name].equality = {
          attribute: field.getAttribute("data-match"),
          comparator: FormValidator.equalityComparator
        };
        if (field.hasAttribute("data-match-error")) {
          constraints[name].equality.message = "^" + field.getAttribute("data-match-error");
        }
      }

      return constraints;
    }
  }, {
    key: "isRequired",
    value: function isRequired(field) {
      return field.hasAttribute("data-val-required") || field.hasAttribute("data-val-requiredlist");
    }
  }, {
    key: "getMessage",
    value: function getMessage(field) {
      return field.getAttribute("data-val-required") || field.getAttribute("data-val-requiredlist");
    }
  }, {
    key: "createError",
    value: function createError(type) {
      var el = document.createElement("span");
      el.className = "Form-error";
      if (type) {
        el.className += " Form-error--" + type;
      }
      return el;
    }
  }, {
    key: "getContainer",
    value: function getContainer(el) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["c" /* closest */])(".Form-control", el);
    }
  }, {
    key: "enableAction",
    value: function enableAction(el) {
      el.disabled = false;
    }
  }, {
    key: "disableAction",
    value: function disableAction(el) {
      el.disabled = true;
    }
  }, {
    key: "equalityComparator",
    value: function equalityComparator(a, b) {
      return a.toLowerCase() === b.toLowerCase();
    }
  }]);

  function FormValidator(el) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormValidator);

    this.el = el;

    // Get all fields to validate
    this.controls = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["a" /* $ */])("[data-val]", el)));
    this.actions = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["a" /* $ */])("[type=submit]", el)));
    this.fields = this.controls.reduce(FormValidator.getFields, {});

    // Get conditional fields - these will affect the constraints
    this.conditionals = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["a" /* $ */])("[data-condition]", el)));

    // Bindings
    // this.conditionChange = this.conditionChange.bind(this);
    this.validate = this.validate.bind(this);

    // Defaults
    this.liveCheck = 0;

    // Setup
    this.updateConstraints();

    // Observer to watch for constraint changes
    this.observer = new MutationObserver(function () {
      _this.updateConstraints();

      if (_this.liveCheck) _this.validate();
    });

    this.conditionals.forEach(function (el) {
      _this.observer.observe(el, ObserverOptions);
    });

    // Bind events
    this.bind();
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FormValidator, [{
    key: "updateConstraints",
    value: function updateConstraints() {
      this.constraints = this.controls.reduce(FormValidator.getConstraint, {});
    }
  }, {
    key: "bind",
    value: function bind() {
      this.el.addEventListener("submit", this.validate, true);
    }
  }, {
    key: "enableLiveCheck",
    value: function enableLiveCheck() {
      var _this2 = this;

      this.liveCheck = 1;
      this.controls.forEach(function (el) {
        el.addEventListener("blur", _this2.validate);
        el.addEventListener("change", _this2.validate);
      });
    }
  }, {
    key: "validate",
    value: function validate(e) {
      if (!this.liveCheck) this.enableLiveCheck();

      this.results = __WEBPACK_IMPORTED_MODULE_4_validate_js___default()(this.el, this.constraints);

      this.reset();

      if (this.results) {
        if (e && e.type == "submit" && e.preventDefault) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.errors();
      } else {
        // Success handlers here, e.g. analytics
        //dataLayer.push({"event": this.el.getAttribute("data-name")});
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.fields).map(function (x) {
        return _this3.fields[x];
      }).filter(function (x) {
        return x.hasError;
      }).forEach(FormValidator.clear);
    }
  }, {
    key: "errors",
    value: function errors() {
      var _this4 = this;

      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.results);
      keys.map(function (x) {
        return { error: _this4.results[x], field: _this4.fields[x] };
      }).forEach(FormValidator.error);
      Object(__WEBPACK_IMPORTED_MODULE_6__utilities_scrollto__["a" /* scrollTo */])(this.fields[keys[0]].container, -60);
    }
  }]);

  return FormValidator;
}();




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_8__load_manager__["b" /* default */].queue(function () {
  return new __WEBPACK_IMPORTED_MODULE_7__component_manager__["a" /* default */](FormValidator, "[data-js~=validator]");
}, __WEBPACK_IMPORTED_MODULE_8__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "Cy0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_plugin__ = __webpack_require__("2Y3a");






// Class
function ArrowCarouselPlugin(config) {
  if (!(this instanceof ArrowCarouselPlugin)) return new ArrowCarouselPlugin(config);

  this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, ArrowCarouselPlugin.defaults, config);
}

// Extends
ArrowCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_3__base_plugin__["a" /* default */].prototype);
ArrowCarouselPlugin.prototype.constructor = ArrowCarouselPlugin;

// Static
ArrowCarouselPlugin.displayName = "ArrowCarouselPlugin";

ArrowCarouselPlugin.defaults = {
  elements: [{
    key: 'next',
    multiple: false,
    selector: '[data-js~=carousel-next]'
    //scope: () => $1('[data-js~=carousel-controls]')
  }, {
    key: 'previous',
    multiple: false,
    selector: '[data-js~=carousel-prev]'
    //scope: () => $1('[data-js~=carousel-controls]')
  }]
};

// Methods
ArrowCarouselPlugin.prototype.init = function () {
  // Make sure we have the buttons then bind click action
  if (this.carousel.elements.next) {
    this.carousel.elements.next.addEventListener('click', this.carousel.next);
  }

  if (this.carousel.elements.previous) {
    this.carousel.elements.previous.addEventListener('click', this.carousel.prev);
  }
};

ArrowCarouselPlugin.prototype.destroy = function () {
  this.carousel.elements.next.removeEventListener('click');
  this.carousel.elements.previous.removeEventListener('click');
};

/***/ }),

/***/ "D+1E":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("84ik");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "DBWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("GyB/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_selector__ = __webpack_require__("g2zd");






var ComponentManager = function () {
  function ComponentManager(component, selector) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ComponentManager);

    if (!selector || !component) return;

    if (typeof selector !== "string") {
      throw new Error("Selector must be a string. You provided: " + (typeof selector === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(selector)));
    }

    if (typeof component !== "function") {
      throw new Error("Component must be a function (or class). You provided: " + (typeof component === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(component)));
    }

    this.elements = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_selector__["a" /* $ */])(selector)));
    this.component = component;

    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    this.args = args;

    if (this.elements.length) {
      this.components = this.elements.map(this.init, this);
    }
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ComponentManager, [{
    key: "init",
    value: function init(el) {
      var args = this.args.map(function (arg) {
        return typeof arg === "function" ? arg(el) : arg;
      });
      return new (Function.prototype.bind.apply(this.component, [null].concat([el], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args))))();
    }
  }]);

  return ComponentManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ComponentManager);

/***/ }),

/***/ "EPcB":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("w113")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "Et2G":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("jtMz");
var global = __webpack_require__("iY05");
var hide = __webpack_require__("Ut/h");
var Iterators = __webpack_require__("NgBR");
var TO_STRING_TAG = __webpack_require__("+PgN")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "F5oK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("0Qy9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("Xos8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("T4f3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_wallop__ = __webpack_require__("M9Vy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_wallop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_wallop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_base_plugin__ = __webpack_require__("2Y3a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_event__ = __webpack_require__("fMm7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__load_manager__ = __webpack_require__("Q9B1");
















var Carousel = function () {
  function Carousel(el) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

    // Ensure element exists
    this.el = el;
    // console.log(this.el)
    if (!this.el) return;
    // Set defaults
    this.initialised = false;
    this.elements = [];
    this.listeners = {};

    // Setup options
    this.options = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, Carousel.defaults, options);

    // Create wallop instance
    if (!this.wallop) this.wallop = new __WEBPACK_IMPORTED_MODULE_7_wallop___default.a(this.el, this.options.wallop);

    // Bind `this` on methods
    this.bindMethods();

    // Enable plugins
    if (this.options.plugins.length) {
      this.plugins = this.options.plugins.filter(function (x) {
        return x instanceof __WEBPACK_IMPORTED_MODULE_8__plugins_base_plugin__["a" /* default */];
      }).map(function (plugin) {
        return plugin.enable(_this);
      });
    }

    // Get relevant elements
    this.getElements();

    // Resize plugin needs to hijack init - emit preinit to handle init conditions
    var initMethod = typeof this.listeners.preinit !== "undefined" ? this.emit.bind("preinit") : this.init;

    // Initialise on resource load
    __WEBPACK_IMPORTED_MODULE_11__load_manager__["b" /* default */].queue(initMethod, __WEBPACK_IMPORTED_MODULE_11__load_manager__["a" /* QUEUE */].RESOURCES);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Carousel, [{
    key: 'init',
    value: function init() {
      // Set default previous item for animations
      this.wallop.previousItemIndex = this.wallop.currentItemIndex;

      // Initialise Plugins
      this.plugins.forEach(function (plugin) {
        return plugin.init();
      });

      // Ready for extensions
      this.el.dispatchEvent(Object(__WEBPACK_IMPORTED_MODULE_10__utilities_event__["a" /* event */])("ready", {
        carousel: this
      }));

      // Add event listeners
      this.bindEvents();

      // Ready
      this.initialised = true;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.plugins.forEach(function (plugins) {
        return plugins.destroy();
      });
      this.wallop.reset();
      this.listeners = {};
      this.getElements();
      this.initialised = false;
    }
  }, {
    key: 'bindMethods',
    value: function bindMethods() {
      // Self Methods
      this.init = this.init.bind(this);
      this.setPreviousItemState = this.setPreviousItemState.bind(this);

      // Wallop Methods
      this.next = this.wallop.next.bind(this.wallop);
      this.prev = this.wallop.previous.bind(this.wallop);
      this.goTo = this.wallop.goTo.bind(this.wallop);
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      // Update previous state on change
      this.wallop.on('change', this.setPreviousItemState);
    }
  }, {
    key: 'pushElement',
    value: function pushElement() {
      var _options$elements;

      for (var _len = arguments.length, el = Array(_len), _key = 0; _key < _len; _key++) {
        el[_key] = arguments[_key];
      }

      // Make sure we haven't already populated the elements array
      // and that all of the elements we've passed are valid
      if (this.elements.length || el.every(function (x) {
        return typeof x.key !== "string" || typeof x.selector !== "string";
      })) return false;
      (_options$elements = this.options.elements).push.apply(_options$elements, el);
    }
  }, {
    key: 'getElements',
    value: function getElements() {
      var _this2 = this;

      // Get any relevant elements
      this.elements = this.options.elements.reduce(function (elements, el) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, elements, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, el.key, el.multiple ? [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_9__utilities_selector__["a" /* $ */])(el.selector, _this2.getElementScope(el)))) : Object(__WEBPACK_IMPORTED_MODULE_9__utilities_selector__["b" /* $1 */])(el.selector, _this2.getElementScope(el))));
      }, {});
    }
  }, {
    key: 'getElementScope',
    value: function getElementScope(_ref) {
      var scope = _ref.scope;

      return typeof scope === "function" ? scope(this.el) || this.el : this.el;
    }
  }, {
    key: 'setPreviousItemState',
    value: function setPreviousItemState(e) {
      // Update previous item index with the current item
      this.wallop.previousItemIndex = e.detail.currentItemIndex;
    }
  }, {
    key: 'hasPlugin',
    value: function hasPlugin(name) {
      return this.plugins.some(function (x) {
        return x.constructor.displayName === name;
      });
    }
  }, {
    key: 'getPlugin',
    value: function getPlugin(name) {
      return this.plugins.find(function (x) {
        return x.constructor.displayName === name;
      });
    }
  }, {
    key: 'emit',
    value: function emit(evt) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (this.listeners[evt] && this.listeners[evt].length) {
        this.listeners[evt].forEach(function (fn) {
          return fn.apply(undefined, args);
        });
      }
    }
  }, {
    key: 'on',
    value: function on(evt, callback) {
      if (typeof this.listeners[evt] === "undefined") {
        this.listeners[evt] = [];
      }

      this.listeners[evt].push(callback);
    }
  }], [{
    key: 'configureClassnames',
    value: function configureClassnames(base) {
      return {
        baseClass: base,
        buttonPreviousClass: base + '-buttonPrevious',
        buttonNextClass: base + '-buttonNext',
        itemClass: base + '-item',
        currentItemClass: base + '-item--current',
        showPreviousClass: base + '-item--showPrevious',
        showNextClass: base + '-item--showNext',
        hidePreviousClass: base + '-item--hidePrevious',
        hideNextClass: base + '-item--hideNext'
      };
    }
  }, {
    key: 'defaults',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
        elements: [{
          key: 'list',
          multiple: false,
          selector: '[data-js~=carousel-list]'
        }],
        plugins: [],
        wallop: Carousel.configureClassnames("Carousel")
      });
    }
  }]);

  return Carousel;
}();

/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),

/***/ "FFZn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("+V16"), __esModule: true };

/***/ }),

/***/ "FYi9":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tgxx");
var $Object = __webpack_require__("gfTL").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "Fady":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("J0xC");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "G+h4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadResource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("L3Vt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var resources = {};

function loadResource(res) {
  if (resources[res]) return resources[res];

  resources[res] = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var script = createScript(res);
    script.onload = function () {
      return resolve(script);
    };
  });

  return resources[res];
}

function createScript(src) {
  var script = document.createElement('script');
  script.src = src;
  document.body.appendChild(script);
  return script;
}

/***/ }),

/***/ "GHf7":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("NgBR");
var ITERATOR = __webpack_require__("+PgN")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "GUkr":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("iY05");
var macrotask = __webpack_require__("0bh+").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("84ik")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "GZQS":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("Ut/h");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "GiYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export breakpoints */
/* unused harmony export carouselDefaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_settings_utils__ = __webpack_require__("wT75");


var breakpoints = {
  tablet: 660,
  desktop: 1076,
  desktopHd: 1680
};

var carouselDefaults = {
  auto: true,
  dots: true,
  hasVideo: false,
  delay: 10000,
  touch: true,
  wallop: Object(__WEBPACK_IMPORTED_MODULE_0__utilities_settings_utils__["a" /* getWallopClasses */])("Carousel")
};

/* harmony default export */ __webpack_exports__["a"] = ({
  breakpoints: breakpoints,
  carouselDefaults: carouselDefaults
});

/***/ }),

/***/ "GlMj":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("iY05");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "Glja":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "GyB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("6t7t");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("ibPW");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "HO2G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Login */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__forms_validator__ = __webpack_require__("CfMb");





var Login = function () {
  function Login() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Login);

    this.formEl = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js=login]');
    if (this.formEl) {
      this.init();
      this.bind();
      this.privacy();
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Login, [{
    key: "init",
    value: function init() {
      this.loginButton = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js="LoginButton"]', this.formEl);
      this.modal = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-modal="AccountModal"]');
      this.modalHeader = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('h3', this.modal);
      this.modalBody = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('.Modal-body');
      this.modalFooter = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('.Modal-footer');
      this.consentField = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js="Consent"]', this.formEl);
      Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[name="UserName"]', this.formEl).focus();
    }
  }, {
    key: "clearModal",
    value: function clearModal() {
      var _this = this;

      window.document.body.classList.remove('has-modal');
      this.modal.classList.remove('is-open');
      setTimeout(function () {
        _this.modalHeader.innerHTML = "";
        _this.modalBody.innerHTML = "<p>Loading form...</p>";
        _this.modalFooter.innerHTML = "";
      }, 500);
    }
  }, {
    key: "errorMessage",
    value: function errorMessage(err) {
      this.modalHeader.innerHTML = "Error: " + err.status;
      this.modalBody.innerHTML = '<p>There has been an error, please try again later.</p>';
    }
  }, {
    key: "bind",
    value: function bind() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-target="AccountModal"]', this.formEl).addEventListener('click', function (e) {
        fetch('/account/getforgottenpasswordform/').then(function (response) {
          if (response.status !== 200) {
            throw response;
          }
          return response.json();
        }).then(function (response) {
          _this2.fetchResetPassword(response);
          _this2.postResetPassword();
        }).catch(function (err) {
          console.log(err);
          _this2.errorMessage(err);
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js="modal-close"]', this.modal).addEventListener('click', this.clearModal.bind(this));
    }
  }, {
    key: "fetchResetPassword",
    value: function fetchResetPassword(data) {
      this.modalHeader.innerHTML = data.formtitle;
      this.modalBody.innerHTML = '<form class="Login-reset" data-form="ForgotPassword">' + data.partialview.replace('<br />', '') + '</form>';
      this.modalFooter.innerHTML = "";

      var control = document.createElement('div');
      var field = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[name="EmailAddress"]', this.modalBody);
      var button = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('input[type="button"]', this.modalBody);

      control.classList.add('Form-control');
      button.className = "Button Button--primary u-mt1";
      button.setAttribute("type", "submit");
      field.classList.add('Input');
      field.setAttribute("data-val", "");
      field.setAttribute("data-val-required", "Please provide a 'Email Address'");
      field.setAttribute("data-regex", "^[-\\w]+@[-\\w.]+\\.[-\\w]+$");
      field.setAttribute("data-val-regex", "Sorry, that is not a valid email address");
      field.parentNode.insertBefore(control, field);
      control.appendChild(field);
      field.focus();
    }
  }, {
    key: "postResetPassword",
    value: function postResetPassword() {
      var _this3 = this;

      var form = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-form="ForgotPassword"]');
      new __WEBPACK_IMPORTED_MODULE_3__forms_validator__["a" /* FormValidator */](form);

      form.addEventListener('submit', function (e) {

        if (e.defaultPrevented) return;

        form.setAttribute('disabled', true);

        var formData = new FormData();
        formData.append("email", Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[name="EmailAddress"]').value);

        fetch('/account/ForgottenPassword/', {
          method: "POST",
          body: formData
        }).then(function (response) {
          if (response.status !== 200) {
            throw response;
          }
          return response.json();
        }).then(function (response) {
          _this3.modalBody.innerHTML = response.returnmessage;
          if (!response.success) form.setAttribute('disabled', false);
        }).catch(function (err) {
          console.log(err);
          _this3.errorMessage(err);
        });

        e.preventDefault();
      });
    }
  }, {
    key: "privacy",
    value: function privacy() {
      var _this4 = this;

      this.acceptButton = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js="Privacy"]');

      if (!this.acceptButton) return;

      this.loginButton.setAttribute('disabled', true);

      this.acceptButton.addEventListener('click', function (e) {
        e.preventDefault();
        _this4.fetchPrivacyPolicy();
      });

      this.fetchPrivacyPolicy();
    }
  }, {
    key: "fetchPrivacyPolicy",
    value: function fetchPrivacyPolicy() {
      var _this5 = this;

      fetch('/policies/getprivacypolicy/').then(function (response) {
        if (response.status !== 200) {
          throw response;
        }
        return response.json();
      }).then(function (response) {

        _this5.modalHeader.innerHTML = "Privacy Policy";
        _this5.modalBody.innerHTML = '<div id="privacycontent" class="cms">' + response.partialview + '</div>';
        _this5.modalFooter.innerHTML = '<button id="acceptBtn" class="Button Button-large Button--pass" data-js="Accept" data-content="Accept" disabled="true">Accept</button> <button id="rejectBtn" class="Button Button-large Button--fail" data-js="Reject" data-content="Reject">Reject</button>';

        window.document.body.classList.add('has-modal');
        _this5.modal.classList.add('is-open');

        var acceptFormButton = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js="Accept"]', _this5.modal);
        var rejectFormButton = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js="Reject"]', _this5.modal);
        var privacyContent = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('#privacycontent');
        var errorEl = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('.Form-error--password');

        acceptFormButton.addEventListener('click', function () {
          _this5.consentField.value = true;
          _this5.acceptButton.classList.add('Button--pass');
          _this5.acceptButton.classList.remove('Button--fail');
          errorEl.style.display = 'none';
          _this5.loginButton.removeAttribute('disabled');
          _this5.clearModal();
        });

        rejectFormButton.addEventListener('click', function () {
          _this5.consentField.value = false;
          _this5.clearModal();
        });

        _this5.modal.onscroll = function (ev) {
          if (!_this5.modal.classList.contains('is-open')) return;

          if (_this5.modal.clientHeight + _this5.modal.scrollTop >= privacyContent.offsetHeight) {
            acceptFormButton.removeAttribute('disabled');
            _this5.modal.onscroll = null;
          }
        };
      }).catch(function (err) {
        console.log(err);
        _this5.errorMessage(err);
        window.document.body.classList.add('has-modal');
        _this5.modal.classList.add('is-open');
      });
    }
  }]);

  return Login;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (new Login());

/***/ }),

/***/ "HhDR":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("J7qu");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("Ku2z").set });


/***/ }),

/***/ "Hy/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("BX4+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auto_plugin__ = __webpack_require__("NBgl");





// Class
function ResponsiveCarouselPlugin(config) {
  if (!(this instanceof ResponsiveCarouselPlugin)) return new ResponsiveCarouselPlugin(config);

  this.options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, ResponsiveCarouselPlugin.defaults, config);
  this.cache = null;
}

// Extends
ResponsiveCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_3__auto_plugin__["a" /* default */].prototype);
ResponsiveCarouselPlugin.prototype.constructor = ResponsiveCarouselPlugin;

// Static
ResponsiveCarouselPlugin.displayName = "ResponsiveCarouselPlugin";

ResponsiveCarouselPlugin.defaults = {
  condition: function condition(e, v) {
    return true;
  }
};

// Methods
ResponsiveCarouselPlugin.prototype.enable = function (carousel) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(this).enable(carousel);

  this.cache = carousel.el.cloneNode(true);

  carousel.on("preinit", this.preinit.bind(this));

  return this;
};

ResponsiveCarouselPlugin.prototype.preinit = function () {
  if (!this.carousel.hasPlugin("ResizerCarouselPlugin")) {
    throw new Error("Responsive plugin cannot work without the resizer plugin");
  }

  if (typeof this.options.conditions === "function") this.carousel.on("resized", this.resize.bind(this));
};

ResponsiveCarouselPlugin.prototype.destroy = function () {
  //this.carousel.el.parentNode.replaceChild(this.cache, this.carousel.el);
  this.carousel.el.innerHTML = this.cache.innerHTML;
};

ResponsiveCarouselPlugin.prototype.resize = function (e, v) {
  // If condition is met and we are yet to init
  var check = this.options.conditions(e, v);
  if (check && !this.carousel.initialised) {
    this.carousel.init();
  } else if (!check && this.carousel.initialised) {
    this.carousel.destroy();
  }
};

/***/ }),

/***/ "Hy4L":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("J65m");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "IMlZ":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("/FIT");
var ITERATOR = __webpack_require__("+PgN")('iterator');
var Iterators = __webpack_require__("NgBR");
module.exports = __webpack_require__("gfTL").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "IvbB":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("J1mN")('asyncIterator');


/***/ }),

/***/ "J0xC":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UcPu");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "J1mN":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("iY05");
var core = __webpack_require__("gfTL");
var LIBRARY = __webpack_require__("z7RH");
var wksExt = __webpack_require__("7Q5m");
var defineProperty = __webpack_require__("V0Rs").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "J65m":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "J7qu":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("iY05");
var core = __webpack_require__("gfTL");
var ctx = __webpack_require__("fAwT");
var hide = __webpack_require__("Ut/h");
var has = __webpack_require__("8nki");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "JUM1":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("6bUA")('meta');
var isObject = __webpack_require__("UcPu");
var has = __webpack_require__("8nki");
var setDesc = __webpack_require__("V0Rs").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("w113")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "JWjT":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("UcPu");
var document = __webpack_require__("iY05").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "Jxjq":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("+PgN")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "KZxa":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "KqgR":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("HhDR");
module.exports = __webpack_require__("gfTL").Object.setPrototypeOf;


/***/ }),

/***/ "Ku2z":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("UcPu");
var anObject = __webpack_require__("J0xC");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("fAwT")(Function.call, __webpack_require__("48TN").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "L3Vt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("R4Ec"), __esModule: true };

/***/ }),

/***/ "L9zC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0Khi");
module.exports = __webpack_require__("gfTL").Object.assign;


/***/ }),

/***/ "LB79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("fAwT");
var $export = __webpack_require__("J7qu");
var toObject = __webpack_require__("Y2mk");
var call = __webpack_require__("Fady");
var isArrayIter = __webpack_require__("GHf7");
var toLength = __webpack_require__("Hy4L");
var createProperty = __webpack_require__("5LE+");
var getIterFn = __webpack_require__("IMlZ");

$export($export.S + $export.F * !__webpack_require__("Jxjq")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "LUWG":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "MUot":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("iY05");
var core = __webpack_require__("gfTL");
var dP = __webpack_require__("V0Rs");
var DESCRIPTORS = __webpack_require__("EPcB");
var SPECIES = __webpack_require__("+PgN")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "McJw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("J7qu");
var newPromiseCapability = __webpack_require__("W57f");
var perform = __webpack_require__("Glja");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "N0Vt":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "NBgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AutoCarouselPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_plugin__ = __webpack_require__("2Y3a");




function AutoCarouselPlugin(config) {
  if (!(this instanceof AutoCarouselPlugin)) return new AutoCarouselPlugin(config);

  // Setup defaults
  this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, AutoCarouselPlugin.defaults, config);
  this.isPlaying = false;
  this.isHover = false;
  this.start = this.start.bind(this);
  this.stop = this.stop.bind(this);

  this.mouseenter = this.mouseenter.bind(this);
  this.mouseleave = this.mouseleave.bind(this);
}

// Extends
AutoCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__base_plugin__["a" /* default */].prototype);
AutoCarouselPlugin.prototype.constructor = AutoCarouselPlugin;

// Static
AutoCarouselPlugin.displayName = "AutoCarouselPlugin";

AutoCarouselPlugin.defaults = {
  delay: 7000
};

// Methods
AutoCarouselPlugin.prototype.init = function () {
  this.carousel.el.addEventListener("mouseenter", this.mouseenter);
  this.carousel.el.addEventListener("mouseleave", this.mouseleave);

  if (this.carousel.hasPlugin("VisibilityCarouselPlugin")) {
    this.carousel.on("enter", this.start);
    this.carousel.on("leave", this.stop);
  } else {
    this.start();
  }
};

AutoCarouselPlugin.prototype.destroy = function () {
  this.carousel.el.removeEventListener("mouseenter", this.mouseenter);
  this.carousel.el.removeEventListener("mouseenter", this.mouseleave);
};

AutoCarouselPlugin.prototype.start = function () {
  if (this.carousel.wallop.allItemsArray.length > 1 && !this.isPlaying) {
    this.isPlaying = true;
    this.interval = setInterval(this.carousel.next, this.options.delay);
  }
};

AutoCarouselPlugin.prototype.stop = function () {
  if (this.isPlaying) {
    this.isPlaying = false;
    clearInterval(this.interval);
  }
};

AutoCarouselPlugin.prototype.mouseenter = function (e) {
  this.isHover = true;
  this.stop();
};

AutoCarouselPlugin.prototype.mouseleave = function (e) {
  this.isHover = false;
  this.start();
};

/***/ }),

/***/ "NgBR":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "O0x3":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("J7qu");
var core = __webpack_require__("gfTL");
var fails = __webpack_require__("w113");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "Ofef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemberSearch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("aIIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("kcQR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animejs__ = __webpack_require__("NQR3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_parse_query__ = __webpack_require__("Bsd1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__load_manager__ = __webpack_require__("Q9B1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__html_map__ = __webpack_require__("9WN3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__templates_member_list__ = __webpack_require__("PES6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__templates_spinner__ = __webpack_require__("dauz");
















var API_URL = "http://pra-rmi-members.01.visarcwebdev.co.uk/membersearch/";

var MemberSearch = function () {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MemberSearch, null, [{
    key: "getUrl",
    value: function getUrl() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return API_URL + "?" + Object(__WEBPACK_IMPORTED_MODULE_6__utilities_parse_query__["a" /* stringifyQuery */])(query);
    }
  }, {
    key: "createMarker",
    value: function createMarker(_ref) {
      var location = _ref.location,
          name = _ref.name,
          telephone = _ref.telephone,
          address1 = _ref.address1,
          address2 = _ref.address2,
          address3 = _ref.address3;

      var address = [address1, address2, address3].filter(function (x) {
        return !!x;
      }).join(", ");

      return {
        position: location,
        title: name,
        address: address,
        content: "<div class=\"InfoWindow\">\n          <h4 class=\"u-mb0\">" + name + "</h4>\n          <address>" + address + "</address>\n          <a href=\"tel:" + telephone + "\">" + telephone + "</a>\n        </div>"
      };
    }
  }]);

  function MemberSearch() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MemberSearch);

    // Get Elements
    this.elements = {
      form: Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["b" /* $1 */])("[data-js=membersearch-form]"),
      map: Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["b" /* $1 */])("[data-js=membersearch-map]"),
      results: Object(__WEBPACK_IMPORTED_MODULE_5__utilities_selector__["b" /* $1 */])("[data-js=membersearch-results]")

      // Check elements
    };if (!this.elements.form || !this.elements.map || !this.elements.results) return;

    if (!this.elements.form) throw new Error("Member Search: Form was not found");

    if (!this.elements.map) throw new Error("Member Search: Map was not found");

    if (!this.elements.results) throw new Error("Member Search: Results list was not found");

    // Bind functions
    this.submit = this.submit.bind(this);
    this.ready = this.ready.bind(this);

    // State
    this.dirty = false;
    this.waiting = false;

    __WEBPACK_IMPORTED_MODULE_7__load_manager__["b" /* default */].queue(this.ready, __WEBPACK_IMPORTED_MODULE_7__load_manager__["a" /* QUEUE */].RESOURCES);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MemberSearch, [{
    key: "ready",
    value: function ready() {
      // Setup map
      this.map = new __WEBPACK_IMPORTED_MODULE_8__html_map__["a" /* Map */](this.elements.map);

      // Listen for searches
      this.elements.form.addEventListener("submit", this.submit);
    }
  }, {
    key: "submit",
    value: function submit(e) {
      e.preventDefault();
      if (this.waiting) return;

      this.search({ q: e.currentTarget.elements[0].value });
      this.revealMap();
    }
  }, {
    key: "search",
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var loading, response, json;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = this.renderLoad();
                _context.prev = 1;
                _context.next = 4;
                return fetch(MemberSearch.getUrl(query));

              case 4:
                response = _context.sent;
                _context.next = 7;
                return response.json();

              case 7:
                json = _context.sent;
                _context.next = 10;
                return loading;

              case 10:
                if (json.length) {
                  this.renderList(json);
                  this.renderMarkers(json);
                } else {
                  this.renderEmpty(query.q);
                }
                this.elements.form.elements[1].innerHTML = "Find a member";
                this.waiting = false;
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 15]]);
      }));

      function search() {
        return _ref2.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "revealMap",
    value: function revealMap() {
      if (this.dirty) return;
      this.dirty = true;
      anim.moveForm(this.elements.form);
    }
  }, {
    key: "renderLoad",
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.waiting = true;
                if (this.map.ready) this.map.clearMarkers();

                this.elements.form.elements[1].innerHTML = Object(__WEBPACK_IMPORTED_MODULE_10__templates_spinner__["a" /* default */])(16);

                this.elements.results.innerHTML = "<p class=\"u-ta-center u-pt2 u-pb2\">" + Object(__WEBPACK_IMPORTED_MODULE_10__templates_spinner__["a" /* default */])(80) + "</p>";

                return _context2.abrupt("return", anim.showResults(this.elements.results).finished);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function renderLoad() {
        return _ref3.apply(this, arguments);
      }

      return renderLoad;
    }()
  }, {
    key: "renderList",
    value: function renderList(model) {
      this.elements.results.innerHTML = Object(__WEBPACK_IMPORTED_MODULE_9__templates_member_list__["a" /* default */])(model);
      anim.showResults(this.elements.results);
    }
  }, {
    key: "renderMarkers",
    value: function renderMarkers(items) {
      if (this.map.ready) this.map.setMarkers(items.map(MemberSearch.createMarker));
    }
  }, {
    key: "renderEmpty",
    value: function renderEmpty(q) {
      this.elements.results.innerHTML = "<div class=\"u-ta-center u-pt2 u-pb2\">\n        <h3>Oh no!</h3>\n        <p>It looks like we don't have any members in \"" + q + "\"</p>\n      </div>";
    }
  }]);

  return MemberSearch;
}();

var anim = {
  moveForm: function moveForm(el) {
    return __WEBPACK_IMPORTED_MODULE_4_animejs___default()({
      targets: el,
      translateY: Math.round(el.parentNode.offsetHeight / 2) + "px",
      easing: 'easeOutSine',
      duration: 350
    });
  },
  showResults: function showResults(el) {
    return __WEBPACK_IMPORTED_MODULE_4_animejs___default()({
      targets: el,
      height: function height(el) {
        return el.firstChild ? el.firstChild.offsetHeight + "px" : 0;
      },
      easing: 'easeOutSine',
      duration: 250
    });
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_7__load_manager__["b" /* default */].queue(function () {
  new MemberSearch();
}, __WEBPACK_IMPORTED_MODULE_7__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "OyEB":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "PAsk":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "PES6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__member__ = __webpack_require__("Bgb+");


/* harmony default export */ __webpack_exports__["a"] = (function (model) {
  return "<ul class=\"MemberList\">\n  " + model.map(item).join("") + "\n</ul>";
});

var item = function item(_item) {
  return "<li class=\"MemberList-item\">" + Object(__WEBPACK_IMPORTED_MODULE_0__member__["a" /* default */])(_item) + "</li>";
};

/***/ }),

/***/ "PPsw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("UDBY")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("ZK8J")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "PmBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__load_manager__ = __webpack_require__("Q9B1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_manager__ = __webpack_require__("DBWF");








var operators = {
  is: function is(target, value) {
    return target == value;
  },
  isNot: function isNot(target, value) {
    return target != value;
  },
  greaterThen: function greaterThen(target, value) {
    var a = parseInt(target);
    var b = parseInt(value);
    if (a && b) {
      return a > b;
    } else {
      return target.length > value.length;
    }
  },
  lessThen: function lessThen(target, value) {
    var a = parseInt(target);
    var b = parseInt(value);
    if (a && b) {
      return a < b;
    } else {
      return target.length < value.length;
    }
  },
  startsWith: function startsWith(target, value) {
    return target.startsWith(value);
  },
  endsWith: function endsWith(target, value) {
    return target.endsWith(value);
  },
  contains: function contains(target, value) {
    return target.includes(value);
  }
};

var fieldTypes = ["INPUT", "SELECT", "TEXTAREA"];

var fieldSelector = fieldTypes.join(",");

var observerOptions = {
  childList: true,
  subtree: true
};

var FormConditions = function () {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FormConditions, null, [{
    key: "getFieldValue",

    // Get Values from fields and RadioNodeLists (containing either radios or checkboxes)
    value: function getFieldValue(field) {
      if (typeof field.length == "undefined" || field.tagName == "SELECT") return field.value;

      var len = field.length;

      if (field[0].type == "radio") {

        for (var i = 0; i < len; i++) {
          var el = field[i];
          if (el.checked) return el.value;
        }
      } else {

        var rtn = "";
        for (var i = 0; i < len; i++) {
          var el = field[i];
          if (el.checked) rtn += rtn.length ? "," + el.value : el.value;
        }
        return rtn;
      }
      return "";
    }
  }, {
    key: "show",
    value: function show(condition) {
      condition.el.style.display = "block";
      condition.visibleFields.forEach(FormConditions.enableField);
    }
  }, {
    key: "hide",
    value: function hide(condition) {
      condition.el.style.display = "none";
      condition.visibleFields.forEach(function (x) {
        FormConditions.resetField(x);
        FormConditions.disableField(x);
        x.dispatchEvent(FormConditions.createChangeEvent());
      });
    }
  }, {
    key: "isField",
    value: function isField(el) {
      return fieldTypes.includes(el.tagName);
    }
  }, {
    key: "resetField",
    value: function resetField(el) {
      switch (el.type) {
        case "checkbox":
        case "radio":
          el.checked = false;
          break;
        default:
          el.value = el.children.length ? el.children[0].value : "";
      }
    }
  }, {
    key: "enableField",
    value: function enableField(el) {
      el.removeAttribute("disabled");
    }
  }, {
    key: "disableField",
    value: function disableField(el) {
      el.setAttribute("disabled", true);
    }
  }, {
    key: "isVisibleField",
    value: function isVisibleField(el) {
      return el.type !== "hidden";
    }
  }, {
    key: "getJsonAttribute",
    value: function getJsonAttribute(el, name) {
      return JSON.parse(el.getAttribute("data-" + name));
    }
  }, {
    key: "createChangeEvent",
    value: function createChangeEvent() {
      return new CustomEvent("change", {
        bubbles: true
      });
    }
  }]);

  function FormConditions(el) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FormConditions);

    if (!el) return;
    this.el = el;

    // Get fields with conditions
    this.fields = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_3__utilities_selector__["a" /* $ */])("[data-condition]", this.el)));

    if (!this.fields.length) return;

    // Build list of all fields
    this.fieldDictionary = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(el.elements)).reduce(function (fields, field) {
      if (fields[field.name]) {
        if (Array.isArray(fields[field.name])) {
          fields[field.name].push(field);
        } else {
          fields[field.name] = [fields[field.name], field];
        }
      } else {
        fields[field.name] = field;
      }
      return fields;
    }, {});

    // Build condition list
    this.conditions = this.fields.map(function (el) {
      var fields = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_3__utilities_selector__["a" /* $ */])(fieldSelector, el)));
      return {
        el: el,
        fields: fields,
        condition: FormConditions.getJsonAttribute(el, "condition"),
        rules: FormConditions.getJsonAttribute(el, "rules"),
        visibleFields: fields.filter(FormConditions.isVisibleField)
      };
    });

    // Bindings
    this.change = this.change.bind(this);
    this.evaluateCondition = this.evaluateCondition.bind(this);

    // Watch for new elements being added
    this.observer = new MutationObserver(function (mutations) {
      mutations.forEach(_this.handleMutation);
    });

    // Add all fields to observer
    this.fields.forEach(function (el) {
      return _this.observer.observe(el, observerOptions);
    });

    // Prepare conditions
    this.conditions.forEach(this.evaluateCondition);

    // Listen to change events
    this.el.addEventListener("change", this.change, true);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FormConditions, [{
    key: "change",
    value: function change(e) {
      this.update(e.target);
    }
  }, {
    key: "update",
    value: function update(target) {
      var affected = this.conditions.filter(function (c) {
        return c.rules.some(function (r) {
          return r.field === target.name;
        });
      });
      affected.forEach(this.evaluateCondition);
    }

    // This should evaluate conditions and then show/hide the associated elements.

  }, {
    key: "evaluateCondition",
    value: function evaluateCondition(condition) {
      var _this2 = this;

      var logic = condition.condition.logicType === "any" ? "some" : "every";

      var conditionMet = condition.rules[logic](function (r) {
        return operators[r.Operator](FormConditions.getFieldValue(_this2.fieldDictionary[r.field]), r.value);
      });

      var actionType = condition.condition.actionType;
      var action = conditionMet ? actionType : actionType === "hide" ? "show" : "hide";

      FormConditions[action](condition);
    }

    // Track any newly added fields
    // Ensures fields are toggled correctly, even if added dynamically
    // This is so that we can handle dynamic input types which add elements
    // e.g. calendars

  }, {
    key: "handleMutation",
    value: function handleMutation(mutation) {
      if (mutation.type != "childList" || !mutation.addedNodes.length) return;

      var nodes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(mutation.addedNodes));

      if (!nodes.some(FormConditions.isField)) return;

      // Find condition for existing fieldset
      var fieldset = mutation.target.getAttribute("data-fieldset");
      var condition = this.conditions.find(function (x) {
        return x.el.id == fieldset;
      });

      if (!condition) return;

      // Add new elements to condition
      nodes.filter(FormConditions.isField).forEach(function (field) {
        condition.fields.push(field);

        if (FormConditions.isVisibleField(field)) {
          condition.visibleFields.push(field);
        }
      });
    }
  }]);

  return FormConditions;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_4__load_manager__["b" /* default */].queue(function () {
  return new __WEBPACK_IMPORTED_MODULE_5__component_manager__["a" /* default */](FormConditions, "[data-js~=conditions]");
}, __WEBPACK_IMPORTED_MODULE_4__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "Pn1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Modal = function () {
  function Modal(el) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    this.el = el;
    this.type = el.getAttribute('type');
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Modal, [{
    key: 'trigger',
    value: function trigger(e) {
      this.open(e.currentTarget.getAttribute('data-target'));
    }
  }, {
    key: 'open',
    value: function open() {
      this.el.classList.add('is-open');
    }
  }, {
    key: 'close',
    value: function close() {
      this.el.classList.remove('is-open');
    }
  }]);

  return Modal;
}();

/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),

/***/ "PtVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hammerjs__ = __webpack_require__("3vhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base_plugin__ = __webpack_require__("2Y3a");





// Class
function TouchCarouselPlugin(config) {
  if (!(this instanceof TouchCarouselPlugin)) return new TouchCarouselPlugin(config);

  this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, TouchCarouselPlugin.defaults, config);

  this.swipe = this.swipe.bind(this);
}

// Extends
TouchCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_3__base_plugin__["a" /* default */].prototype);
TouchCarouselPlugin.prototype.constructor = TouchCarouselPlugin;

// Static
TouchCarouselPlugin.displayName = "TouchCarouselPlugin";

TouchCarouselPlugin.defaults = {
  elements: [{
    key: 'touch',
    multiple: false,
    selector: '[data-js~=carousel-touch]'
  }],
  hammer: {
    recognizers: [[__WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.Swipe, { direction: __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.DIRECTION_HORIZONTAL }]]
  }
};

// Methods
TouchCarouselPlugin.prototype.init = function () {
  var els = this.carousel.elements;
  this.el = els.touch || els.list || this.carousel.el;

  if (this.el) {
    this.hammer = new __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.Manager(this.el, this.options.hammer);
  }

  if (els.dots.length) {
    // Change cursor if there are multiple carousel items
    this.el.style.cursor = "ew-resize";
  }

  this.hammer.on("swipe", this.swipe);
  this.autoPlugin = this.carousel.getPlugin("AutoCarouselPlugin") || null;
};

TouchCarouselPlugin.prototype.destroy = function () {
  this.hammer.destroy();
  this.hammer = null;
};

TouchCarouselPlugin.prototype.swipe = function (e) {
  if (e.direction === __WEBPACK_IMPORTED_MODULE_2_hammerjs___default.a.DIRECTION_LEFT) {
    this.carousel.next();
  } else {
    this.carousel.prev();
  }
  if (this.autoPlugin) {
    this.autoPlugin.stop();
  }
};

/***/ }),

/***/ "Q9B1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QUEUE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("Xos8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var QUEUE = {
  DOM: "DOM",
  RESOURCES: "RESOURCES"
};

var LoadManager = function () {
  function LoadManager() {
    var _events,
        _loaded,
        _this = this;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LoadManager);

    this.events = (_events = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_events, QUEUE.DOM, []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_events, QUEUE.RESOURCES, []), _events);
    this.loaded = (_loaded = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loaded, QUEUE.DOM, false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_loaded, QUEUE.RESOURCES, false), _loaded);

    this.run = function (queue, e) {
      _this.loaded[queue] = true;

      //   console.log(queue, this.events[queue]);
      //   performance.now();
      //   performance.mark("Start loop: " + queue);
      //   this.events[queue].forEach((evt, i) => {
      //     let name = i + '(' + evt.name + ')';
      //     performance.mark("Start load: " + name);
      //     evt()
      //     performance.mark("End load: " + name);
      //     performance.measure("Load: " + name, "Start load: " + name, "End load: " + name);
      //   });
      //   performance.now();
      //   performance.mark("End loop: " + queue);
      //   performance.measure("Loop: " + queue, "Start loop: " + queue, "End loop: " + queue);

      _this.events[queue].forEach(function (evt) {
        return evt();
      });

      _this.unbind(queue);
    };

    this.bind();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LoadManager, [{
    key: "bind",
    value: function bind() {
      this.runDomQueue = this.run.bind(this, QUEUE.DOM);
      this.runResourceQueue = this.run.bind(this, QUEUE.RESOURCES);
      document.addEventListener("DOMContentLoaded", this.runDomQueue);
      window.addEventListener("load", this.runResourceQueue);
    }
  }, {
    key: "unbind",
    value: function unbind(queue) {
      switch (queue) {
        case QUEUE.DOM:
          document.removeEventListener("DOMContentLoaded", this.runDomQueue);
          break;

        case QUEUE.RESOURCES:
          window.removeEventListener("load", this.runResourceQueue);
      }
    }
  }, {
    key: "queue",
    value: function queue(func, _queue) {
      if (typeof func !== 'function') {
        throw new Error('Event must be a function');
      }

      if (typeof _queue === "undefined") {
        throw new Error("Load Queue must be defined");
      }

      if (typeof this.loaded[_queue] !== "boolean" || typeof this.loaded[_queue] !== "undefined" && !Array.isArray(this.events[_queue])) {
        throw new Error("Load Queue type does not exist");
      }

      this.events[_queue].push(func);
      if (this.loaded[_queue]) {
        func();
      }
    }
  }]);

  return LoadManager;
}();

/* harmony default export */ __webpack_exports__["b"] = (new LoadManager());

/***/ }),

/***/ "QZxg":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("jUky");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "R4Ec":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4dTo");
__webpack_require__("PPsw");
__webpack_require__("Et2G");
__webpack_require__("btXG");
__webpack_require__("8h33");
__webpack_require__("McJw");
module.exports = __webpack_require__("gfTL").Promise;


/***/ }),

/***/ "SB6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrows_plugin__ = __webpack_require__("Cy0b");
/* unused harmony reexport ArrowsPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auto_plugin__ = __webpack_require__("NBgl");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__auto_plugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dnlinks_plugin__ = __webpack_require__("4yv0");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__dnlinks_plugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dots_plugin__ = __webpack_require__("6BzV");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__dots_plugin__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__height_plugin__ = __webpack_require__("zOCD");
/* unused harmony reexport HeightPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resizer_plugin__ = __webpack_require__("dCRJ");
/* unused harmony reexport ResizerPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__responsive_plugin__ = __webpack_require__("Hy/P");
/* unused harmony reexport ResponsivePlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__touch_plugin__ = __webpack_require__("PtVM");
/* unused harmony reexport TouchPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transition_plugin__ = __webpack_require__("wbCl");
/* unused harmony reexport TransitionPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__video_plugin__ = __webpack_require__("Wo9q");
/* unused harmony reexport VideoPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__visibility_plugin__ = __webpack_require__("bHRu");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__visibility_plugin__["a"]; });












/***/ }),

/***/ "Sjlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_helpers_toggler__ = __webpack_require__("UTZw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_helpers_tables__ = __webpack_require__("25lL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_helpers_scroll_to__ = __webpack_require__("a5Jr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_member_search__ = __webpack_require__("Ofef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_carousels__ = __webpack_require__("9NUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modals_manager__ = __webpack_require__("TZmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_dn_media_links__ = __webpack_require__("spxZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dn_help_links__ = __webpack_require__("iuFu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_validator__ = __webpack_require__("CfMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_forms_conditions__ = __webpack_require__("PmBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_login__ = __webpack_require__("HO2G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_social__ = __webpack_require__("nBKQ");
// And away we go















/***/ }),

/***/ "T4f3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("gc0D");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "TRtI":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("gfTL");
var global = __webpack_require__("iY05");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("z7RH") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "TXMg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("iY05");
var has = __webpack_require__("8nki");
var DESCRIPTORS = __webpack_require__("EPcB");
var $export = __webpack_require__("J7qu");
var redefine = __webpack_require__("Y4Ow");
var META = __webpack_require__("JUM1").KEY;
var $fails = __webpack_require__("w113");
var shared = __webpack_require__("TRtI");
var setToStringTag = __webpack_require__("tgxk");
var uid = __webpack_require__("6bUA");
var wks = __webpack_require__("+PgN");
var wksExt = __webpack_require__("7Q5m");
var wksDefine = __webpack_require__("J1mN");
var enumKeys = __webpack_require__("pEKD");
var isArray = __webpack_require__("bYsY");
var anObject = __webpack_require__("J0xC");
var isObject = __webpack_require__("UcPu");
var toObject = __webpack_require__("Y2mk");
var toIObject = __webpack_require__("hS2E");
var toPrimitive = __webpack_require__("UMw4");
var createDesc = __webpack_require__("wRUo");
var _create = __webpack_require__("+Dtb");
var gOPNExt = __webpack_require__("iFkG");
var $GOPD = __webpack_require__("48TN");
var $GOPS = __webpack_require__("OyEB");
var $DP = __webpack_require__("V0Rs");
var $keys = __webpack_require__("kk7b");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("aQU6").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("LUWG").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("z7RH")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("Ut/h")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "TZmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("8FtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modal_base__ = __webpack_require__("Pn1b");




// Utilities


// Components
// import modals from './';


var ModalManager = function () {
  function ModalManager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalManager);

    this.modalEls = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_selector__["a" /* $ */])('[data-modal]')));
    this.modals = {};
    this.triggers = {
      open: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_selector__["a" /* $ */])('[data-js~=modal-open]'))),
      close: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_4__utilities_selector__["a" /* $ */])('[data-js~=modal-close]')))
    };
    if (this.modalEls.length) this.init();
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ModalManager, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.modalEls.map(function (el) {
        return _this.create(el);
      });
      this.bind();
      //return this;
    }
  }, {
    key: 'create',
    value: function create(el) {
      // let type = el.getAttribute('data-type');
      this.modals[el.getAttribute('data-modal')] = new __WEBPACK_IMPORTED_MODULE_5__modal_base__["a" /* default */](el);
    }
  }, {
    key: 'bind',
    value: function bind() {
      var _this2 = this;

      console.log(this.triggers);
      this.triggers.open.map(function (el) {
        el.addEventListener('click', function (e) {
          return _this2.open(e);
        });
      });

      this.triggers.close.map(function (el) {
        el.addEventListener('click', function (e) {
          return _this2.close();
        });
      });

      window.addEventListener('keyup', function (e) {
        if (e.keyCode == 27) _this2.close();
      });
    }
  }, {
    key: 'open',
    value: function open(e) {
      this.close();
      document.body.classList.add('has-modal');
      this.modals[e.currentTarget.getAttribute('data-target')].open();
    }
  }, {
    key: 'close',
    value: function close() {
      var _this3 = this;

      document.body.classList.remove('has-modal');
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.modals).map(function (modal) {
        _this3.modals[modal].close();
      });
    }
  }]);

  return ModalManager;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (new ModalManager());

/***/ }),

/***/ "UDBY":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("J65m");
var defined = __webpack_require__("PAsk");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "UMw4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("UcPu");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "UTZw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Toggler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("8FtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__load_manager__ = __webpack_require__("Q9B1");






var Toggler = function Toggler(el) {
  el = el || Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js~=toggler]');

  if (!el) return;

  if (!el.hasAttribute('data-id')) throw new Error("Togglable element must have an ID");

  var target = el.getAttribute('data-id');

  var triggers = {
    open: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["a" /* $ */])('[data-js~=toggler-open][data-target=' + target + ']'))),
    close: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["a" /* $ */])('[data-js~=toggler-close][data-target=' + target + ']'))),
    toggle: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["a" /* $ */])('[data-js~=toggler-toggle][data-target=' + target + ']')))
  };

  if (!triggers.open.length && !triggers.close.length && !triggers.toggle.length) throw new Error('Togglable element ' + target + ' has no triggers');

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(triggers).forEach(function (action) {
    triggers[action].forEach(function (el) {
      el.addEventListener('click', Toggler[action]);
    });
  });
};

Toggler.getTarget = function (el) {
  var id = el.getAttribute('data-target');
  var target = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["b" /* $1 */])('[data-js~=toggler][data-id=' + id + ']');
  if (!target) throw new Error('Target ' + id + ' was not found');

  return target;
};

Toggler.open = function (e) {
  var target = Toggler.getTarget(e.currentTarget);
  target.classList.add('is-open');
};

Toggler.close = function (e) {
  var target = Toggler.getTarget(e.currentTarget);
  target.classList.remove('is-open');
};

Toggler.toggle = function (e) {
  var target = Toggler.getTarget(e.currentTarget);
  target.classList.toggle('is-open');
  this.classList.toggle('is-open');
};

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_3__load_manager__["b" /* default */].queue(function () {
  [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_2__utilities_selector__["a" /* $ */])("[data-js~=toggler]"))).forEach(Toggler);
}, __WEBPACK_IMPORTED_MODULE_3__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "UcPu":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "Ut/h":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("V0Rs");
var createDesc = __webpack_require__("wRUo");
module.exports = __webpack_require__("EPcB") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "V0Rs":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("J0xC");
var IE8_DOM_DEFINE = __webpack_require__("xkmf");
var toPrimitive = __webpack_require__("UMw4");
var dP = Object.defineProperty;

exports.f = __webpack_require__("EPcB") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "VOrx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("GyB/");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "Vjiw":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("J7qu");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("EPcB"), 'Object', { defineProperty: __webpack_require__("V0Rs").f });


/***/ }),

/***/ "VuZO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("kJIO"), __esModule: true };

/***/ }),

/***/ "W57f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("mCxV");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "Wo9q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auto_plugin__ = __webpack_require__("NBgl");




// Class
function VideoCarouselPlugin(config) {
  if (!(this instanceof VideoCarouselPlugin)) return new VideoCarouselPlugin(config);

  this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, VideoCarouselPlugin.defaults, config);
  this.videos = [];
  this.auto = false;
  this.change = this.change.bind(this);
  this.onPlay = this.onPlay.bind(this);
  this.onPause = this.onPause.bind(this);
}

// Extends
VideoCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__auto_plugin__["a" /* default */].prototype);
VideoCarouselPlugin.prototype.constructor = VideoCarouselPlugin;

// Static
VideoCarouselPlugin.displayName = "VideoCarouselPlugin";

VideoCarouselPlugin.defaults = {
  elements: [{
    key: 'videos',
    multiple: true,
    selector: '[data-js~=carousel-video]'
  }],
  condition: null
};

VideoCarouselPlugin.stop = function (video) {
  video.pause();
  video.currentTime = 0;
};

// Methods
VideoCarouselPlugin.prototype.init = function () {
  if (!this.carousel.elements.videos.length) return;

  this.carousel.wallop.on("change", this.change);

  // If auto is on, we want to stop it when the video starts
  if (this.carousel.hasPlugin("AutoCarouselPlugin")) {
    this.auto = this.carousel.getPlugin("AutoCarouselPlugin");
    this.videos.forEach(this.handleAuto.bind(this));
  }
};

VideoCarouselPlugin.prototype.destroy = function () {
  this.auto = null;
  video.removeEventListener('play', this.onPlay);
  video.removeEventListener('pause', this.onPause);
};

VideoCarouselPlugin.prototype.handleAuto = function (video) {
  video.addEventListener('play', this.onPlay);
  video.addEventListener('pause', this.onPause);
};

VideoCarouselPlugin.prototype.onPlay = function (e) {
  this.auto.stop();
};

VideoCarouselPlugin.prototype.onPause = function (e) {
  !e.target.ended || this.carousel.next();
  this.auto.start();
};

VideoCarouselPlugin.prototype.change = function (e) {
  if (typeof this.options.condition === "function" && !this.options.condition()) return;
  var wallop = this.carousel.wallop;

  // Stop previous video if exists and reset
  if (!isNaN(wallop.previousItemIndex)) {
    var old = items[wallop.previousItemIndex].querySelector("video");
    if (old) {
      this.currentSlideIsVideo = false;
      this.stop(old);
    }
  }

  // Play new video if exists
  var video = wallop.allItemsArray[e.detail.currentItemIndex].querySelector("video");
  if (video) {
    this.currentSlideIsVideo = true;
    video.play();
  }
};

/***/ }),

/***/ "XSTj":
/***/ (function(module, exports) {

module.exports = [{"featureType":"administrative.neighborhood","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"hue":"#ff0000"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"color":"#f7f1df"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#d0e3b4"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"geometry","stylers":[{"color":"#fbd3da"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#bde6ab"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffe15f"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#efd151"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"black"}]},{"featureType":"transit.station.airport","elementType":"geometry.fill","stylers":[{"color":"#cfb2db"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#a2daf2"}]}]

/***/ }),

/***/ "Xos8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("FFZn");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "Y2mk":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("PAsk");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "Y4Ow":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("Ut/h");


/***/ }),

/***/ "Y85c":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "YlTb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("J65m");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "Z2n/":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("8nki");
var toIObject = __webpack_require__("hS2E");
var arrayIndexOf = __webpack_require__("1lYT")(false);
var IE_PROTO = __webpack_require__("kXVo")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "ZK8J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("z7RH");
var $export = __webpack_require__("J7qu");
var redefine = __webpack_require__("Y4Ow");
var hide = __webpack_require__("Ut/h");
var Iterators = __webpack_require__("NgBR");
var $iterCreate = __webpack_require__("gvBj");
var setToStringTag = __webpack_require__("tgxk");
var getPrototypeOf = __webpack_require__("8QSD");
var ITERATOR = __webpack_require__("+PgN")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "ZKjc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("Aq8W");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("yeEC");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("GyB/");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "a5Jr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScrollTo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_scrollto__ = __webpack_require__("6mUc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_offset__ = __webpack_require__("cFxj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__optimisations_optimised_resize_manager__ = __webpack_require__("/XSW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_manager__ = __webpack_require__("DBWF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__load_manager__ = __webpack_require__("Q9B1");











var scrollEl = document.scrollingElement || document.documentElement || document.body;

var comparePosition = {
  above: function above(p, h) {
    return scrollEl.scrollTop < p;
  },
  below: function below(p, h) {
    return scrollEl.scrollTop > p + h;
  }
};

var ScrollTo = function () {
  function ScrollTo(el) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollTo);

    this.el = el;
    this.conditions = [];
    this.init();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollTo, [{
    key: 'init',
    value: function init() {
      if (this.el.hasAttribute('data-target')) {
        this.target = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_selector__["b" /* $1 */])('[data-anchor=' + this.el.getAttribute('data-target') + ']');

        if (this.target) {
          if (this.el.hasAttribute('data-scroll-conditions')) {
            this.conditions = this.el.getAttribute('data-scroll-conditions').split(' ').filter(function (x) {
              return typeof comparePosition[x] === "function";
            });
          }

          __WEBPACK_IMPORTED_MODULE_8__load_manager__["b" /* default */].queue(this.ready.bind(this), __WEBPACK_IMPORTED_MODULE_8__load_manager__["a" /* QUEUE */].RESOURCES);
        } else {
          console.warn("ScrollTo target could not be found");
        }
      } else {
        console.warn("ScrollTo trigger element must have a target");
      }
    }
  }, {
    key: 'ready',
    value: function ready() {
      var _this = this;

      // Calculate the offset from the size of the header
      // Update when the browser resizes
      __WEBPACK_IMPORTED_MODULE_6__optimisations_optimised_resize_manager__["a" /* DebouncedResizeManager */].add({
        action: function action() {
          _this.offset = parseInt(document.body.style.paddingTop || 95);
        }
      });
      this.bind();
    }
  }, {
    key: 'bind',
    value: function bind() {
      this.el.addEventListener('click', this.go.bind(this));
    }
  }, {
    key: 'go',
    value: function go(e) {
      if (!this.conditions.length || this.checkConditions()) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utilities_scrollto__["a" /* scrollTo */])(this.target, -this.offset);
        this.target.focus();
      }
    }
  }, {
    key: 'targetBounds',
    value: function targetBounds() {
      return [Object(__WEBPACK_IMPORTED_MODULE_5__utilities_offset__["a" /* getOffset */])(this.target) - this.offset, this.target.offsetHeight];
    }
  }, {
    key: 'checkConditions',
    value: function checkConditions() {
      var t = this.targetBounds();
      return this.conditions.some(function (x) {
        return comparePosition[x].apply(comparePosition, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(t));
      });
    }
  }]);

  return ScrollTo;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_8__load_manager__["b" /* default */].queue(function () {
  return new __WEBPACK_IMPORTED_MODULE_7__component_manager__["a" /* default */](ScrollTo, '[data-js~=scroll-to]');
}, __WEBPACK_IMPORTED_MODULE_8__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "aIIw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("QZxg");


/***/ }),

/***/ "aQU6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("Z2n/");
var hiddenKeys = __webpack_require__("Y85c").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "bHRu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VISIBILITY_EVENTS */
/* harmony export (immutable) */ __webpack_exports__["a"] = VisibilityCarouselPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auto_plugin__ = __webpack_require__("NBgl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_in_view__ = __webpack_require__("tsq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__optimisations_throttled_scroll_manager__ = __webpack_require__("5zwf");







// Constants
var VISIBILITY_EVENTS = {
  ENTER: "enter",
  LEAVE: "leave"
};

// Class
function VisibilityCarouselPlugin(config) {
  if (!(this instanceof VisibilityCarouselPlugin)) return new VisibilityCarouselPlugin(config);

  // Setup defaults
  this.isVisible = false;
  this.check = this.check.bind(this);
}

// Extends
VisibilityCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_1__auto_plugin__["a" /* default */].prototype);
VisibilityCarouselPlugin.prototype.constructor = VisibilityCarouselPlugin;

// Static
VisibilityCarouselPlugin.displayName = "VisibilityCarouselPlugin";

// Methods
VisibilityCarouselPlugin.prototype.init = function () {
  this.scrollEvent = __WEBPACK_IMPORTED_MODULE_3__optimisations_throttled_scroll_manager__["a" /* default */].add({
    action: this.check
  });
};

VisibilityCarouselPlugin.prototype.destroy = function () {
  __WEBPACK_IMPORTED_MODULE_3__optimisations_throttled_scroll_manager__["a" /* default */].remove(this.scrollEvent);
};

VisibilityCarouselPlugin.prototype.check = function () {
  var visible = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_in_view__["a" /* isInView */])(this.carousel.el);
  if (visible !== this.isVisible) {
    this.isVisible = visible;
    this.carousel.emit(visible ? VISIBILITY_EVENTS.ENTER : VISIBILITY_EVENTS.LEAVE);
  }
};

/***/ }),

/***/ "bPR/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("x/V+");
module.exports = __webpack_require__("gfTL").Object.keys;


/***/ }),

/***/ "bYsY":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("84ik");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "bbx/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var debounce = function debounce(type, name, obj, rate) {
  obj = obj || window;
  var timeout = null;
  var detail = {};

  var func = function func(e) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }

    detail = { detail: { originalEvent: e } };

    timeout = setTimeout(function () {
      obj.dispatchEvent(new CustomEvent(name, detail));
      timeout = null;
    }, rate);
  };

  obj.addEventListener(type, func);
};

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),

/***/ "btXG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("z7RH");
var global = __webpack_require__("iY05");
var ctx = __webpack_require__("fAwT");
var classof = __webpack_require__("/FIT");
var $export = __webpack_require__("J7qu");
var isObject = __webpack_require__("UcPu");
var aFunction = __webpack_require__("mCxV");
var anInstance = __webpack_require__("N0Vt");
var forOf = __webpack_require__("lrvQ");
var speciesConstructor = __webpack_require__("nj1l");
var task = __webpack_require__("0bh+").set;
var microtask = __webpack_require__("GUkr")();
var newPromiseCapabilityModule = __webpack_require__("W57f");
var perform = __webpack_require__("Glja");
var userAgent = __webpack_require__("GlMj");
var promiseResolve = __webpack_require__("ilQA");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("+PgN")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("GZQS")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("tgxk")($Promise, PROMISE);
__webpack_require__("MUot")(PROMISE);
Wrapper = __webpack_require__("gfTL")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("Jxjq")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "cFxj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffset;
function getOffset(el) {
  var offset = el.offsetTop;
  while (el != document.body) {
    el = el.parentNode;
    if (getComputedStyle(el).position == "static") continue;
    offset += el.offsetTop;
  }
  return offset;
}

/***/ }),

/***/ "dACh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "dCRJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auto_plugin__ = __webpack_require__("NBgl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__optimisations_optimised_resize_manager__ = __webpack_require__("/XSW");





// Class
function ResizerCarouselPlugin(config) {
  if (!(this instanceof ResizerCarouselPlugin)) return new ResizerCarouselPlugin(config);

  this.throttled = this.emit.bind(this, "resizing");
  this.debounced = this.emit.bind(this, "resized");
}

// Extends
ResizerCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_1__auto_plugin__["a" /* default */].prototype);
ResizerCarouselPlugin.prototype.constructor = ResizerCarouselPlugin;

// Static
ResizerCarouselPlugin.displayName = "ResizerCarouselPlugin";

// Methods
ResizerCarouselPlugin.prototype.init = function () {
  this.actions = [__WEBPACK_IMPORTED_MODULE_2__optimisations_optimised_resize_manager__["b" /* ThrottledResizeManager */].add({
    action: this.throttled
  }), __WEBPACK_IMPORTED_MODULE_2__optimisations_optimised_resize_manager__["a" /* DebouncedResizeManager */].add({
    action: this.debounced
  })];
};

ResizerCarouselPlugin.prototype.destroy = function () {
  __WEBPACK_IMPORTED_MODULE_2__optimisations_optimised_resize_manager__["b" /* ThrottledResizeManager */].remove(this.actions[0]);
  __WEBPACK_IMPORTED_MODULE_2__optimisations_optimised_resize_manager__["a" /* DebouncedResizeManager */].remove(this.actions[1]);
};

ResizerCarouselPlugin.prototype.emit = function (event) {
  var _carousel;

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  (_carousel = this.carousel).emit.apply(_carousel, [event].concat(args));
};

/***/ }),

/***/ "dauz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (size) {
  return "<svg class=\"Spinner\" width=\"" + size + "\" height=\"" + size + "\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\">\n  <circle class=\"Spinner-inner\" cx=\"50\" cy=\"50\" r=\"35\" fill=\"none\" stroke-width=\"" + 100 / size * 4 + "px\" stroke=\"#ccc\" />\n  </svg>";
});

/***/ }),

/***/ "f9aD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var throttle = function throttle(type, name, obj) {
  obj = obj || window;
  var running = false;
  var detail = {};
  var func = function func(e) {
    if (running) {
      return;
    }
    running = true;
    detail = { detail: { originalEvent: e } };
    requestAnimationFrame(function () {
      obj.dispatchEvent(new CustomEvent(name, detail));
      running = false;
    });
  };
  obj.addEventListener(type, func);
};

/* harmony default export */ __webpack_exports__["a"] = (throttle);

/***/ }),

/***/ "fAwT":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("mCxV");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "fMm7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = event;
/**
 * Create a custom event
 * @param {string} type The event to create
 * @param {*} detail The data to send with the event
 */
function event(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  params = params.detail || params.bubbles || params.cancellable ? params : { detail: params };
  return new CustomEvent(type, params);
}

/***/ }),

/***/ "fkkt":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("V0Rs");
var anObject = __webpack_require__("J0xC");
var getKeys = __webpack_require__("kk7b");

module.exports = __webpack_require__("EPcB") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "g/Af":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("TXMg");
__webpack_require__("4dTo");
__webpack_require__("IvbB");
__webpack_require__("vWK2");
module.exports = __webpack_require__("gfTL").Symbol;


/***/ }),

/***/ "g2zd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = $;
/* harmony export (immutable) */ __webpack_exports__["b"] = $1;
/* harmony export (immutable) */ __webpack_exports__["c"] = closest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

function $(el, scope) {
  return (scope || document).querySelectorAll(el);
}

function $1(el, scope) {
  return (scope || document).querySelector(el);
}

function closest(selector, el) {
  var elements = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()($(selector)));
  if (!elements.length) return null;
  do {
    el = el.parentNode;
  } while (el && elements.indexOf(el) == -1);
  return el;
}

/***/ }),

/***/ "gDg+":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("Y2mk");
var $getPrototypeOf = __webpack_require__("8QSD");

__webpack_require__("O0x3")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "gc0D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("L9zC"), __esModule: true };

/***/ }),

/***/ "gfTL":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "gvBj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("+Dtb");
var descriptor = __webpack_require__("wRUo");
var setToStringTag = __webpack_require__("tgxk");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("Ut/h")(IteratorPrototype, __webpack_require__("+PgN")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "hS2E":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("D+1E");
var defined = __webpack_require__("PAsk");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "haD7":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "iFkG":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("hS2E");
var gOPN = __webpack_require__("aQU6").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "iY05":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "ibPW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("g/Af"), __esModule: true };

/***/ }),

/***/ "id70":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "ilQA":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("J0xC");
var isObject = __webpack_require__("UcPu");
var newPromiseCapability = __webpack_require__("W57f");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "iuFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__load_manager__ = __webpack_require__("Q9B1");






// Class

var DNLinks = function () {
  function DNLinks() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DNLinks);

    this.items = Object(__WEBPACK_IMPORTED_MODULE_3_utilities_selector__["a" /* $ */])('[data-dnlink]');
    if (!this.items) return;

    __WEBPACK_IMPORTED_MODULE_4__load_manager__["b" /* default */].queue(this.init.bind(this), __WEBPACK_IMPORTED_MODULE_4__load_manager__["a" /* QUEUE */].RESOURCES);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DNLinks, [{
    key: 'init',
    value: function init() {
      [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.items)).forEach(this.setupLinks, this);
    }
  }, {
    key: 'setupLinks',
    value: function setupLinks(el) {
      var link = Object(__WEBPACK_IMPORTED_MODULE_3_utilities_selector__["b" /* $1 */])('[data-link]', el);
      var target = Object(__WEBPACK_IMPORTED_MODULE_3_utilities_selector__["b" /* $1 */])('[data-target]', el);
      var url = link.innerHTML.trim();

      if (url != "" && url != "Link goes here") {
        target.setAttribute('data-target', true);
        target.addEventListener('click', function () {
          window.open(url, "_self");
        });
      }
    }
  }]);

  return DNLinks;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_4__load_manager__["b" /* default */].queue(function () {
  return new DNLinks();
}, __WEBPACK_IMPORTED_MODULE_4__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "jUky":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "jtMz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("KZxa");
var step = __webpack_require__("haD7");
var Iterators = __webpack_require__("NgBR");
var toIObject = __webpack_require__("hS2E");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("ZK8J")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "jx4H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("FFZn");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "k8O+":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("iY05").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "kJIO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("PPsw");
__webpack_require__("LB79");
module.exports = __webpack_require__("gfTL").Array.from;


/***/ }),

/***/ "kXVo":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("TRtI")('keys');
var uid = __webpack_require__("6bUA");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "kcQR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("L3Vt");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "kk7b":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Z2n/");
var enumBugKeys = __webpack_require__("Y85c");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "lrvQ":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("fAwT");
var call = __webpack_require__("Fady");
var isArrayIter = __webpack_require__("GHf7");
var anObject = __webpack_require__("J0xC");
var toLength = __webpack_require__("Hy4L");
var getIterFn = __webpack_require__("IMlZ");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "mCxV":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "mYpx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("VuZO");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "nBKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__load_manager__ = __webpack_require__("Q9B1");






var SocialShare = function () {
  function SocialShare() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SocialShare);

    this.el = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_selector__["b" /* $1 */])('[data-js~=social-share]');
    this.buttons = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Object(__WEBPACK_IMPORTED_MODULE_3__utilities_selector__["a" /* $ */])('[data-js~=social-share-btn]', this.el)));
    this.windowHeight = 490;
    this.windowWidth = 655;

    if (!this.el) return false;

    __WEBPACK_IMPORTED_MODULE_4__load_manager__["b" /* default */].queue(this.init.bind(this), __WEBPACK_IMPORTED_MODULE_4__load_manager__["a" /* QUEUE */].RESOURCES);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SocialShare, [{
    key: 'init',
    value: function init() {
      this.bind();
    }
  }, {
    key: 'bind',
    value: function bind() {
      var _this = this;

      this.buttons.map(function (el) {
        el.addEventListener('click', function (e) {
          _this.popupClick(el);
        });
      });
    }
  }, {
    key: 'popupClick',
    value: function popupClick(e) {
      event.preventDefault();
      this.windowUrl = e.getAttribute("href");
      this.windowName = e.getAttribute("data-share");

      window.open(this.windowUrl, this.windowName, 'width=' + this.windowWidth + ',height=' + this.windowHeight);
    }
  }]);

  return SocialShare;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_4__load_manager__["b" /* default */].queue(function () {
  return new SocialShare();
}, __WEBPACK_IMPORTED_MODULE_4__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "nj1l":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("J0xC");
var aFunction = __webpack_require__("mCxV");
var SPECIES = __webpack_require__("+PgN")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "pEKD":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("kk7b");
var gOPS = __webpack_require__("OyEB");
var pIE = __webpack_require__("LUWG");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "skJn":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("UcPu");
var meta = __webpack_require__("JUM1").onFreeze;

__webpack_require__("O0x3")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "spxZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("mYpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utilities_selector__ = __webpack_require__("g2zd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__load_manager__ = __webpack_require__("Q9B1");






// Class

var DNMediaLinks = function () {
  function DNMediaLinks() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DNMediaLinks);

    this.mediaItems = Object(__WEBPACK_IMPORTED_MODULE_3_utilities_selector__["a" /* $ */])('[data-media]');
    if (!this.mediaItems) return;

    __WEBPACK_IMPORTED_MODULE_4__load_manager__["b" /* default */].queue(this.init.bind(this), __WEBPACK_IMPORTED_MODULE_4__load_manager__["a" /* QUEUE */].RESOURCES);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DNMediaLinks, [{
    key: 'init',
    value: function init() {
      [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.mediaItems)).forEach(this.setupLinks, this);
    }
  }, {
    key: 'setupLinks',
    value: function setupLinks(el) {
      var link = Object(__WEBPACK_IMPORTED_MODULE_3_utilities_selector__["b" /* $1 */])('[data-link]', el);
      var target = Object(__WEBPACK_IMPORTED_MODULE_3_utilities_selector__["b" /* $1 */])('[data-target]', el);
      var url = link.innerHTML.trim();

      if (url != "" && url != "Link goes here") {
        target.setAttribute('data-target', true);
        target.addEventListener('click', function () {
          window.open(url, '_blank');
        });
      }
    }
  }]);

  return DNMediaLinks;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_4__load_manager__["b" /* default */].queue(function () {
  return new DNMediaLinks();
}, __WEBPACK_IMPORTED_MODULE_4__load_manager__["a" /* QUEUE */].DOM));

/***/ }),

/***/ "tB/S":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("skJn");
module.exports = __webpack_require__("gfTL").Object.freeze;


/***/ }),

/***/ "tgxk":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("V0Rs").f;
var has = __webpack_require__("8nki");
var TAG = __webpack_require__("+PgN")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "tgxx":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("J7qu");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("+Dtb") });


/***/ }),

/***/ "tsq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInView;
function isInView(el) {
  var rect = el.getBoundingClientRect();

  return (rect.top >= 0 && rect.top <= window.innerHeight || rect.bottom >= 0 && rect.bottom <= window.innerHeight) && (rect.left >= 0 && rect.left <= window.innerWidth || rect.right >= 0 && rect.right <= window.innerWidth);
}

/***/ }),

/***/ "uRdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("dACh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("jx4H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__load_manager__ = __webpack_require__("Q9B1");





var generateId = function generateId() {
  return Math.random().toString(36).substring(2) + new Date().getTime().toString(36);
};

var OptimisedEventManager = function () {
  // Properties
  function OptimisedEventManager(_ref) {
    var _this = this;

    var func = _ref.func,
        event = _ref.event,
        newEvent = _ref.newEvent,
        obj = _ref.obj,
        rate = _ref.rate;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OptimisedEventManager);

    this.events = [];
    this.defaults = {
      priority: 10,
      min: 0,
      max: Infinity
    };

    this.run = function (e) {
      // Cache params
      var p = _this.params();

      _this.events.forEach(function (evt) {
        // Check if event has it's own conditions
        var condition = evt.condition || _this.condition;

        if (condition(evt, p, e)) {
          evt.action(e, p);
        }
      });
    };

    // Store event names
    this.event = event;
    this.newEvent = newEvent;
    this.obj = obj || window;

    // Create new optimised custom event
    func(this.event, this.newEvent, this.obj, rate);

    // Run once just in case anything is already bound
    this.run({});

    // Bind the event listener
    this.bind();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OptimisedEventManager, [{
    key: 'bind',
    value: function bind() {
      // Add event listener for custom optimised event
      this.obj.addEventListener(this.newEvent, this.run);
    }
  }, {
    key: 'unbind',
    value: function unbind() {
      // Remove event listener for custom optimised event
      this.obj.window.removeEventListener(this.newEvent, this.run);
    }
  }, {
    key: 'add',
    value: function add(evt) {
      // Create the event object
      var event = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.defaults, evt);

      // Ensure event has action
      if (!'action' in event) {
        throw new Error('Event must have an action');
      }

      // Ensure event action is a function
      if (typeof event.action !== 'function') {
        throw new Error('Event must be a function');
      }

      // Generate event ID
      event.id = generateId();

      // Add new event and sort
      this.events.push(event);
      this.events.sort(this.compare);

      // Cache Params
      var p = this.params();

      // Check if event has it's own conditions
      var condition = evt.condition || this.condition;

      // Run Once to initialise
      if (condition(event, p, {})) {
        event.action({}, p);
      }

      return event.id;
    }
  }, {
    key: 'remove',
    value: function remove(id) {
      this.events = this.events.filter(function (x) {
        return x.id != id;
      });
    }

    // Parameter generation method

  }, {
    key: 'params',
    value: function params() {
      return {
        size: window.innerWidth
      };
    }

    // Run the bound events

  }, {
    key: 'condition',


    // Check if event conditions are met
    value: function condition(evt, p, e) {
      return evt.min <= parseInt(p.size) && evt.max >= parseInt(p.size);
    }

    // Comparison for sorting events by priority

  }, {
    key: 'compare',
    value: function compare(a, b) {
      if (a.priority < b.priority) {
        return -1;
      } else if (a.priority > b.priority) {
        return 1;
      }
      return 0;
    }
  }]);

  return OptimisedEventManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (OptimisedEventManager);

/***/ }),

/***/ "v8Hs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("EPcB");
var getKeys = __webpack_require__("kk7b");
var gOPS = __webpack_require__("OyEB");
var pIE = __webpack_require__("LUWG");
var toObject = __webpack_require__("Y2mk");
var IObject = __webpack_require__("D+1E");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("w113")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "vWK2":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("J1mN")('observable');


/***/ }),

/***/ "w113":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "wRUo":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "wT75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getWallopClasses; });
var getWallopClasses = function getWallopClasses(base) {
  return {
    baseClass: base,
    buttonPreviousClass: base + "-buttonPrevious",
    buttonNextClass: base + "-buttonNext",
    itemClass: base + "-item",
    currentItemClass: "is-active",
    showPreviousClass: base + "-item--showPrevious",
    showNextClass: base + "-item--showNext",
    hidePreviousClass: base + "-item--hidePrevious",
    hideNextClass: base + "-item--hideNext"
  };
};

/***/ }),

/***/ "wbCl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auto_plugin__ = __webpack_require__("NBgl");




// Class
function TransitionCarouselPlugin(config) {
  if (!(this instanceof TransitionCarouselPlugin)) return new TransitionCarouselPlugin(config);

  // Setup defaults
  this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, TransitionCarouselPlugin.defaults, config);
}

// Extends
TransitionCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__auto_plugin__["a" /* default */].prototype);
TransitionCarouselPlugin.prototype.constructor = TransitionCarouselPlugin;

// Static Methods
TransitionCarouselPlugin.displayName = "TransitionCarouselPlugin";

TransitionCarouselPlugin.defaults = {
  transition: function transition(el) {},
  methods: {
    enter: 'play',
    leave: 'playBackwards'
  }
};

// Methods
TransitionCarouselPlugin.prototype.init = function () {
  this.timelines = this.carousel.wallop.allItemsArray.map(this.options.transition.bind(this));

  if (this.timelines.length) {
    this.enter(this.carousel.wallop.currentItemIndex);
  }

  this.carousel.wallop.on('change', this.change.bind(this));
};

TransitionCarouselPlugin.prototype.change = function (e) {
  if (!isNaN(this.carousel.wallop.previousItemIndex)) {
    this.leave(this.carousel.wallop.previousItemIndex);
  }
  this.enter(e.detail.currentItemIndex);
};

TransitionCarouselPlugin.prototype.run = function (key, i) {
  var tl = this.timelines[i];
  var m = this.options.methods[key];
  if (tl && m && typeof tl[m] === "function") tl[m]();
};

TransitionCarouselPlugin.prototype.enter = function (i) {
  this.run("enter", i);
};

TransitionCarouselPlugin.prototype.leave = function (i) {
  this.run("leave", i);
};

/***/ }),

/***/ "x/V+":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("Y2mk");
var $keys = __webpack_require__("kk7b");

__webpack_require__("O0x3")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "xkmf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("EPcB") && !__webpack_require__("w113")(function () {
  return Object.defineProperty(__webpack_require__("JWjT")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "yeEC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("FYi9"), __esModule: true };

/***/ }),

/***/ "z7RH":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "zOCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("yeEC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("gc0D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_plugin__ = __webpack_require__("2Y3a");




function HeightCarouselPlugin(config) {
  if (!(this instanceof HeightCarouselPlugin)) return new HeightCarouselPlugin(config);

  // Setup defaults
  this.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, HeightCarouselPlugin.defaults, config);

  this.setHeight = this.setHeight.bind(this);
}

// Extends
HeightCarouselPlugin.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(__WEBPACK_IMPORTED_MODULE_2__base_plugin__["a" /* default */].prototype);
HeightCarouselPlugin.prototype.constructor = HeightCarouselPlugin;

// Static
HeightCarouselPlugin.displayName = "HeightCarouselPlugin";

HeightCarouselPlugin.defaults = {
  className: ""
};

HeightCarouselPlugin.prototype.init = function () {
  this.el = this.carousel.elements.list || this.carousel.el;

  if (this.options.className) this.el.classList.add(this.options.className);

  this.carousel.wallop.on("change", this.setHeight);

  if (this.carousel.hasPlugin("ResizerCarouselPlugin")) {
    this.carousel.on("resizing", this.setHeight);
  }
};

HeightCarouselPlugin.prototype.destroy = function () {
  this.el.classList.remove(this.options.className);
  this.el.style.height = "auto";
};

HeightCarouselPlugin.prototype.setHeight = function (e) {
  var index = e.detail ? e.detail.currentItemIndex : this.carousel.wallop.currentItemIndex;

  var el = this.carousel.wallop.allItemsArray[index];
  if (el) {
    this.el.style.height = el.offsetHeight + 'px';
  }
};

/***/ })

},["Sjlv"]);


// WEBPACK FOOTER //
// scripts/site.26678b46179538c65305.js